var _style, _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path, _rect9, _path2, _path3, _polygon, _polygon2, _polygon3, _polygon4, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _path4, _path5, _path6, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _rect16, _rect17, _path7, _polygon10, _polygon11, _polygon12, _polygon13, _path8, _path9, _path10, _path11, _path12, _g, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _polygon14, _polygon15, _path24, _path25, _path26, _path27, _path28, _polygon16, _polygon17, _path29, _path30, _path31, _polygon18, _polygon19, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _rect18, _path50, _path51, _path52, _path53, _path54, _path55, _rect19, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _g2, _path71, _path72, _path73, _path74, _rect20, _path75, _path76, _path77, _polygon20, _path78, _path79, _path80, _polygon21, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _rect21, _path93, _rect22, _path94, _rect23, _path95, _rect24, _path96, _rect25, _path97, _rect26, _path98, _rect27, _path99, _rect28, _path100, _rect29, _path101, _rect30, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _g3, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _g4, _path124, _path125, _path126, _polygon22, _polygon23, _path127, _g5, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _g6, _rect47, _path135, _polygon24, _path136, _rect48, _path137, _polygon25, _path138;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlog3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 900 600",
    style: {
      enableBackground: "new 0 0 900 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);fill:url(#SVGID_3_);}\r\n\t.st1{clip-path:url(#SVGID_2_);}\r\n\t.st2{fill:url(#SVGID_4_);}\r\n\t.st3{fill:url(#SVGID_5_);}\r\n\t.st4{fill:url(#SVGID_6_);}\r\n\t.st5{fill:url(#SVGID_7_);}\r\n\t.st6{fill:url(#SVGID_8_);}\r\n\t.st7{fill:url(#SVGID_9_);}\r\n\t.st8{fill:url(#SVGID_10_);}\r\n\t.st9{fill:url(#SVGID_11_);}\r\n\t.st10{fill:url(#SVGID_12_);}\r\n\t.st11{fill:url(#SVGID_13_);}\r\n\t.st12{fill:url(#SVGID_14_);}\r\n\t.st13{fill:url(#SVGID_15_);}\r\n\t.st14{fill:url(#SVGID_16_);}\r\n\t.st15{fill:url(#SVGID_17_);}\r\n\t.st16{fill:url(#SVGID_18_);}\r\n\t.st17{fill:url(#SVGID_19_);}\r\n\t.st18{fill:url(#SVGID_20_);}\r\n\t.st19{fill:url(#SVGID_21_);}\r\n\t.st20{fill:url(#SVGID_22_);}\r\n\t.st21{fill:url(#SVGID_23_);}\r\n\t.st22{fill:url(#SVGID_24_);}\r\n\t.st23{fill:url(#SVGID_25_);}\r\n\t.st24{fill:url(#SVGID_26_);}\r\n\t.st25{fill:url(#SVGID_27_);}\r\n\t.st26{fill:url(#SVGID_28_);}\r\n\t.st27{fill:url(#SVGID_29_);}\r\n\t.st28{fill:url(#SVGID_30_);}\r\n\t.st29{fill:url(#SVGID_31_);}\r\n\t.st30{fill:url(#SVGID_32_);}\r\n\t.st31{fill:url(#SVGID_33_);}\r\n\t.st32{fill:url(#SVGID_34_);}\r\n\t.st33{fill:url(#SVGID_35_);}\r\n\t.st34{fill:url(#SVGID_36_);}\r\n\t.st35{fill:url(#SVGID_37_);}\r\n\t.st36{fill:url(#SVGID_38_);}\r\n\t.st37{fill:url(#SVGID_39_);}\r\n\t.st38{fill:url(#SVGID_40_);}\r\n\t.st39{fill:url(#SVGID_41_);}\r\n\t.st40{fill:#00FFFF;}\r\n\t.st41{fill:url(#SVGID_42_);}\r\n\t.st42{fill:url(#SVGID_43_);}\r\n\t.st43{fill:#02247D;}\r\n\t.st44{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_44_);}\r\n\t.st45{fill:url(#SVGID_45_);}\r\n\t.st46{fill:url(#SVGID_46_);}\r\n\t.st47{fill:url(#SVGID_47_);}\r\n\t.st48{fill:url(#SVGID_48_);}\r\n\t.st49{fill:url(#SVGID_49_);}\r\n\t.st50{fill:url(#SVGID_50_);}\r\n\t.st51{fill:url(#SVGID_51_);}\r\n\t.st52{fill:url(#SVGID_52_);}\r\n\t.st53{fill:url(#SVGID_53_);}\r\n\t.st54{fill:url(#SVGID_54_);}\r\n\t.st55{fill:url(#SVGID_55_);}\r\n\t.st56{fill:url(#SVGID_56_);}\r\n\t.st57{fill:url(#SVGID_57_);}\r\n\t.st58{fill:url(#SVGID_58_);}\r\n\t.st59{fill:url(#SVGID_59_);}\r\n\t.st60{fill:url(#SVGID_60_);}\r\n\t.st61{fill:url(#SVGID_61_);}\r\n\t.st62{fill:url(#SVGID_62_);}\r\n\t.st63{fill:url(#SVGID_63_);}\r\n\t.st64{fill:url(#SVGID_64_);}\r\n\t.st65{fill:url(#SVGID_65_);}\r\n\t.st66{fill:url(#SVGID_66_);}\r\n\t.st67{fill:url(#SVGID_67_);}\r\n\t.st68{fill:url(#SVGID_68_);}\r\n\t.st69{fill:url(#SVGID_69_);}\r\n\t.st70{fill:url(#SVGID_70_);}\r\n\t.st71{fill:url(#SVGID_71_);}\r\n\t.st72{fill:url(#SVGID_72_);}\r\n\t.st73{fill:url(#SVGID_73_);}\r\n\t.st74{fill:url(#SVGID_74_);}\r\n\t.st75{fill:url(#SVGID_75_);}\r\n\t.st76{fill:url(#SVGID_76_);}\r\n\t.st77{fill:url(#SVGID_77_);}\r\n\t.st78{fill:url(#SVGID_78_);}\r\n\t.st79{fill:url(#SVGID_79_);}\r\n\t.st80{fill:url(#SVGID_80_);}\r\n\t.st81{fill:url(#SVGID_81_);}\r\n\t.st82{fill:url(#SVGID_82_);}\r\n\t.st83{fill:url(#SVGID_83_);}\r\n\t.st84{fill:url(#SVGID_84_);}\r\n\t.st85{fill:url(#SVGID_85_);}\r\n\t.st86{fill:url(#SVGID_86_);}\r\n\t.st87{fill:url(#SVGID_87_);}\r\n\t.st88{fill:url(#SVGID_88_);}\r\n\t.st89{fill:url(#SVGID_89_);}\r\n\t.st90{fill:url(#SVGID_90_);}\r\n\t.st91{fill:url(#SVGID_91_);}\r\n\t.st92{fill:url(#SVGID_92_);}\r\n\t.st93{fill:url(#SVGID_93_);}\r\n\t.st94{fill:url(#SVGID_94_);}\r\n\t.st95{fill:url(#SVGID_95_);}\r\n\t.st96{fill:url(#SVGID_96_);}\r\n\t.st97{fill:url(#SVGID_97_);}\r\n\t.st98{fill:url(#SVGID_98_);}\r\n\t.st99{fill:url(#SVGID_99_);}\r\n\t.st100{fill:url(#SVGID_100_);}\r\n\t.st101{fill:url(#SVGID_101_);}\r\n\t.st102{fill:url(#SVGID_102_);}\r\n\t.st103{fill:url(#SVGID_103_);}\r\n\t.st104{fill:url(#SVGID_104_);}\r\n\t.st105{fill:url(#SVGID_105_);}\r\n\t.st106{fill:url(#SVGID_106_);}\r\n\t.st107{fill:url(#SVGID_107_);}\r\n\t.st108{fill:url(#SVGID_108_);}\r\n\t.st109{fill:url(#SVGID_109_);}\r\n\t.st110{fill:url(#SVGID_110_);}\r\n\t.st111{fill:url(#SVGID_111_);}\r\n\t.st112{fill:url(#SVGID_112_);}\r\n\t.st113{opacity:0.5;fill:#02247D;}\r\n\t.st114{fill:url(#SVGID_113_);}\r\n\t.st115{fill:url(#SVGID_114_);}\r\n\t.st116{fill:url(#SVGID_115_);}\r\n\t.st117{fill:url(#SVGID_116_);}\r\n\t.st118{fill:url(#SVGID_117_);}\r\n\t.st119{fill:url(#SVGID_118_);}\r\n\t.st120{fill:url(#SVGID_119_);}\r\n\t.st121{fill:url(#SVGID_120_);}\r\n\t.st122{fill:url(#SVGID_121_);}\r\n\t.st123{fill:url(#SVGID_122_);}\r\n\t.st124{fill:url(#SVGID_123_);}\r\n\t.st125{fill:url(#SVGID_124_);}\r\n\t.st126{fill:url(#SVGID_125_);}\r\n\t.st127{fill:url(#SVGID_126_);}\r\n\t.st128{fill:url(#SVGID_127_);}\r\n\t.st129{fill:url(#SVGID_128_);}\r\n\t.st130{fill:url(#SVGID_129_);}\r\n\t.st131{fill:url(#SVGID_130_);}\r\n\t.st132{fill:url(#SVGID_131_);}\r\n\t.st133{fill:url(#SVGID_132_);}\r\n\t.st134{fill:url(#SVGID_133_);}\r\n\t.st135{fill:url(#SVGID_134_);}\r\n\t.st136{fill:url(#SVGID_135_);}\r\n\t.st137{fill:url(#SVGID_136_);}\r\n\t.st138{fill:#FFFEFF;}\r\n\t.st139{fill:url(#SVGID_137_);}\r\n\t.st140{fill:url(#SVGID_138_);}\r\n\t.st141{fill:url(#SVGID_139_);}\r\n\t.st142{fill:url(#SVGID_140_);}\r\n\t.st143{fill:url(#SVGID_141_);}\r\n\t.st144{fill:url(#SVGID_142_);}\r\n\t.st145{fill:url(#SVGID_143_);}\r\n\t.st146{fill:url(#SVGID_144_);}\r\n\t.st147{fill-rule:evenodd;clip-rule:evenodd;fill:#02247D;}\r\n\t.st148{fill:url(#SVGID_145_);}\r\n\t.st149{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_146_);}\r\n\t.st150{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_147_);}\r\n\t.st151{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_148_);}\r\n\t.st152{fill:url(#SVGID_149_);}\r\n\t.st153{fill:url(#SVGID_150_);}\r\n\t.st154{fill:url(#SVGID_151_);}\r\n\t.st155{fill:url(#SVGID_152_);}\r\n\t.st156{fill:url(#SVGID_153_);}\r\n\t.st157{fill:url(#SVGID_154_);}\r\n\t.st158{fill:url(#SVGID_155_);}\r\n\t.st159{fill:url(#SVGID_156_);}\r\n\t.st160{fill:url(#SVGID_157_);}\r\n\t.st161{fill:url(#SVGID_158_);}\r\n\t.st162{fill:url(#SVGID_159_);}\r\n\t.st163{fill:url(#SVGID_160_);}\r\n\t.st164{fill:url(#SVGID_161_);}\r\n\t.st165{fill:url(#SVGID_162_);}\r\n\t.st166{fill:url(#SVGID_163_);}\r\n\t.st167{fill:url(#SVGID_164_);}\r\n\t.st168{fill:url(#SVGID_165_);}\r\n\t.st169{fill:url(#SVGID_166_);}\r\n\t.st170{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_167_);}\r\n\t.st171{fill:url(#SVGID_168_);}\r\n\t.st172{fill:url(#SVGID_169_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 900,
    height: 600
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 300.0002,
    x2: 899.9995,
    y2: 300.0002
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#022894"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 900,
    height: 600
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 502.479,
    y1: 245.4849,
    x2: 542.479,
    y2: 245.4849
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 502.48,
    y: 244.48,
    className: "st2",
    width: 40,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 476.7456,
    y1: 93.5527,
    x2: 516.7456,
    y2: 93.5527
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 476.75,
    y: 92.55,
    className: "st3",
    width: 40,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 502.478,
    y1: 261.7642,
    x2: 542.479,
    y2: 261.7642
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 502.48,
    y: 260.76,
    className: "st4",
    width: 40,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 546.645,
    y1: 261.7642,
    x2: 557.5523,
    y2: 261.7642
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 546.65,
    y: 260.76,
    className: "st5",
    width: 10.91,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 516.8775,
    y1: 149.5733,
    x2: 539.2407,
    y2: 149.5733
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 516.88,
    y: 148.57,
    className: "st6",
    width: 22.36,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 442.0244,
    y1: 105.957,
    x2: 464.3872,
    y2: 105.957
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 442.02,
    y: 104.96,
    className: "st7",
    width: 22.36,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 554.8521,
    y1: 164.9063,
    x2: 564.9917,
    y2: 164.9063
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 554.85,
    y: 163.91,
    className: "st8",
    width: 10.14,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 539.2056,
    y1: 176.6631,
    x2: 546.0659,
    y2: 176.6631
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M542.64,180.09c-1.89,0-3.43-1.54-3.43-3.43s1.54-3.43,3.43-3.43c1.89,0,3.43,1.54,3.43,3.43 S544.53,180.09,542.64,180.09z M542.64,175.23c-0.79,0-1.43,0.64-1.43,1.43c0,0.79,0.64,1.43,1.43,1.43 c0.79,0,1.43-0.64,1.43-1.43C544.07,175.87,543.42,175.23,542.64,175.23z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 607.7691,
    y1: 281.563,
    x2: 617.9087,
    y2: 281.563
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 607.77,
    y: 280.56,
    className: "st10",
    width: 10.14,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 592.1226,
    y1: 293.3199,
    x2: 598.9829,
    y2: 293.3199
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M595.55,296.75c-1.89,0-3.43-1.54-3.43-3.43c0-1.89,1.54-3.43,3.43-3.43s3.43,1.54,3.43,3.43 C598.98,295.21,597.44,296.75,595.55,296.75z M595.55,291.89c-0.79,0-1.43,0.64-1.43,1.43c0,0.79,0.64,1.43,1.43,1.43 c0.79,0,1.43-0.64,1.43-1.43C596.98,292.53,596.34,291.89,595.55,291.89z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 416.1807,
    y1: 93.7378,
    x2: 423.0415,
    y2: 93.7378
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M419.61,97.17c-1.89,0-3.43-1.54-3.43-3.43c0-1.89,1.54-3.43,3.43-3.43s3.43,1.54,3.43,3.43 C423.04,95.63,421.5,97.17,419.61,97.17z M419.61,92.31c-0.79,0-1.43,0.64-1.43,1.43c0,0.79,0.64,1.43,1.43,1.43 c0.79,0,1.43-0.64,1.43-1.43C421.04,92.95,420.4,92.31,419.61,92.31z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 511.0073,
    y1: 164.1109,
    x2: 516.437,
    y2: 164.1109
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "512.42,166.83 511.01,165.41 515.02,161.4 516.44,162.81  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 1342.9155,
    y1: 691.6948,
    x2: 1348.3462,
    y2: 691.6948,
    gradientTransform: "matrix(0 1 -1 0 1205.417 -1181.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "515.02,166.83 511.01,162.81 512.42,161.4 516.44,165.41  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 536.4907,
    y1: 114.0684,
    x2: 541.9204,
    y2: 114.0684
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "537.9,116.78 536.49,115.37 540.51,111.35 541.92,112.77  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 1292.8735,
    y1: 666.2114,
    x2: 1298.3032,
    y2: 666.2114,
    gradientTransform: "matrix(0 1 -1 0 1205.417 -1181.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "540.51,116.78 536.49,112.77 537.9,111.35 541.92,115.37  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 1954.7949,
    y1: -99.5107,
    x2: 1994.7949,
    y2: -99.5107,
    gradientTransform: "matrix(-1 0 0 -1 2309.0625 38.3545)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 314.27,
    y: 136.87,
    className: "st17",
    width: 40,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 2115.9893,
    y1: -92.583,
    x2: 2155.9888,
    y2: -92.583,
    gradientTransform: "matrix(-1 0 0 -1 2309.0625 38.3545)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 153.07,
    y: 129.94,
    className: "st18",
    width: 40,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 2014.8013,
    y1: -99.5107,
    x2: 2043.8535,
    y2: -99.5107,
    gradientTransform: "matrix(-1 0 0 -1 2309.0625 38.3545)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 265.21,
    y: 136.87,
    className: "st19",
    width: 29.05,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 2042.1948,
    y1: -85.8965,
    x2: 2050.1162,
    y2: -85.8965,
    gradientTransform: "matrix(-1 0 0 -1 2309.0625 38.3545)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 258.95,
    y: 123.25,
    className: "st20",
    width: 7.92,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 2174.3442,
    y1: -169.8901,
    x2: 2196.7075,
    y2: -169.8901,
    gradientTransform: "matrix(-1 0 0 -1 2309.0625 38.3545)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 112.36,
    y: 207.24,
    className: "st21",
    width: 22.36,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 2211.5684,
    y1: -169.8901,
    x2: 2221.7075,
    y2: -169.8901,
    gradientTransform: "matrix(-1 0 0 -1 2309.0625 38.3545)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 87.36,
    y: 207.24,
    className: "st22",
    width: 10.14,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 2129.3374,
    y1: -61.7378,
    x2: 2136.1987,
    y2: -61.7378,
    gradientTransform: "matrix(-1 0 0 -1 2309.0625 38.3545)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M176.29,103.52c-1.89,0-3.43-1.54-3.43-3.43c0-1.89,1.54-3.43,3.43-3.43c1.89,0,3.43,1.54,3.43,3.43 C179.73,101.98,178.19,103.52,176.29,103.52z M176.29,98.66c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43 c0.79,0,1.43-0.64,1.43-1.43S177.08,98.66,176.29,98.66z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 2203.9155,
    y1: -148.823,
    x2: 2210.7769,
    y2: -148.823,
    gradientTransform: "matrix(-1 0 0 -1 2309.0625 38.3545)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M101.72,190.61c-1.89,0-3.43-1.54-3.43-3.43c0-1.89,1.54-3.43,3.43-3.43c1.89,0,3.43,1.54,3.43,3.43 C105.15,189.07,103.61,190.61,101.72,190.61z M101.72,185.75c-0.79,0-1.43,0.64-1.43,1.43c0,0.79,0.64,1.43,1.43,1.43 c0.79,0,1.43-0.64,1.43-1.43C103.15,186.39,102.51,185.75,101.72,185.75z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 1705.1245,
    y1: -308.5786,
    x2: 1711.9858,
    y2: -308.5786,
    gradientTransform: "matrix(-1 0 0 -1 2309.0625 38.3545)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M600.51,350.36c-1.89,0-3.43-1.54-3.43-3.43c0-1.89,1.54-3.43,3.43-3.43s3.43,1.54,3.43,3.43 C603.94,348.82,602.4,350.36,600.51,350.36z M600.51,345.5c-0.79,0-1.43,0.64-1.43,1.43c0,0.79,0.64,1.43,1.43,1.43 c0.79,0,1.43-0.64,1.43-1.43C601.94,346.14,601.3,345.5,600.51,345.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 2147.335,
    y1: -68.6806,
    x2: 2152.7646,
    y2: -68.6806,
    gradientTransform: "matrix(-1 0 0 -1 2309.0625 38.3545)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "157.71,109.75 156.3,108.34 160.31,104.32 161.73,105.73  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 2147.335,
    y1: -68.6806,
    x2: 2152.7646,
    y2: -68.6806,
    gradientTransform: "matrix(-1 0 0 -1 2309.0625 38.3545)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "157.71,109.75 156.3,108.34 160.31,104.32 161.73,105.73  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 1110.1241,
    y1: -944.6323,
    x2: 1115.5538,
    y2: -944.6323,
    gradientTransform: "matrix(0 -1 1 0 1103.645 1219.8741)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "160.31,109.75 156.3,105.73 157.71,104.32 161.73,108.34  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 2208.062,
    y1: -117.2598,
    x2: 2213.4917,
    y2: -117.2598,
    gradientTransform: "matrix(-1 0 0 -1 2309.0625 38.3545)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "96.98,158.33 95.57,156.92 99.59,152.9 101,154.31  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 1061.545,
    y1: -1005.3594,
    x2: 1066.9747,
    y2: -1005.3594,
    gradientTransform: "matrix(0 -1 1 0 1103.645 1219.8741)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "99.59,158.33 95.57,154.31 96.98,152.9 101,156.92  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 2008.6333,
    y1: -47.9658,
    x2: 2030.9966,
    y2: -47.9658,
    gradientTransform: "matrix(-1 0 0 -1 2309.0625 38.3545)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 278.07,
    y: 85.32,
    className: "st31",
    width: 22.36,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 2045.8574,
    y1: -47.9658,
    x2: 2055.9966,
    y2: -47.9658,
    gradientTransform: "matrix(-1 0 0 -1 2309.0625 38.3545)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 253.07,
    y: 85.32,
    className: "st32",
    width: 10.14,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 1974.7949,
    y1: -55.2441,
    x2: 1981.6562,
    y2: -55.2441,
    gradientTransform: "matrix(-1 0 0 -1 2309.0625 38.3545)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M330.84,97.03c-1.89,0-3.43-1.54-3.43-3.43c0-1.89,1.54-3.43,3.43-3.43s3.43,1.54,3.43,3.43 C334.27,95.49,332.73,97.03,330.84,97.03z M330.84,92.17c-0.79,0-1.43,0.64-1.43,1.43c0,0.79,0.64,1.43,1.43,1.43 c0.79,0,1.43-0.64,1.43-1.43C332.27,92.81,331.63,92.17,330.84,92.17z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 2068.4912,
    y1: -94.4057,
    x2: 2073.9209,
    y2: -94.4057,
    gradientTransform: "matrix(-1 0 0 -1 2309.0625 38.3545)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "236.56,135.48 235.14,134.06 239.16,130.04 240.57,131.46  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 1084.3986,
    y1: -865.7886,
    x2: 1089.8292,
    y2: -865.7886,
    gradientTransform: "matrix(0 -1 1 0 1103.645 1219.8741)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "239.16,135.48 235.14,131.46 236.56,130.04 240.57,134.06  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 1967.2119,
    y1: -80.4668,
    x2: 1972.6421,
    y2: -80.4668,
    gradientTransform: "matrix(-1 0 0 -1 2309.0625 38.3545)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "337.83,121.54 336.42,120.12 340.44,116.11 341.85,117.52  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 1098.338,
    y1: -764.5095,
    x2: 1103.7676,
    y2: -764.5095,
    gradientTransform: "matrix(0 -1 1 0 1103.645 1219.8741)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "340.44,121.54 336.42,117.52 337.83,116.11 341.85,120.12  "
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 150.8649,
    y1: -895.0641,
    x2: 799.7995,
    y2: -895.0641,
    gradientTransform: "matrix(1 0 0 1 -98.8527 1357.3556)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#022894"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F41DB"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M685.01,414.48H67.95c-8.8,0-15.94,7.13-15.94,15.94l0,0c0,8.8,7.13,15.94,15.94,15.94h51.2 c8.8,0,15.94,7.13,15.94,15.94l0,0c0,8.8-7.13,15.94-15.94,15.94H99.88c-8.8,0-15.94,7.13-15.94,15.94l0,0 c0,8.8,7.13,15.94,15.94,15.94h574.9c8.8,0,15.94-7.13,15.94-15.94l0,0c0-8.8-7.13-15.94-15.94-15.94h-2.5 c-8.8,0-15.94-7.13-15.94-15.94l0,0c0-8.8,7.14-15.94,15.94-15.94h12.73c8.8,0,15.94-7.13,15.94-15.94l0,0 C700.95,421.62,693.81,414.48,685.01,414.48z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.6097,
    y1: 253.1271,
    x2: 121.413,
    y2: 253.1271
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M104.4,263.03l1.83-1.83l3.05,3.04c0.61,0.61,1.56,1.12,2.1,0.59l2.69-2.69l-2.08-2.08 c-0.61-0.61-0.41-1.07,0.12-1.61l2.91-2.91c0.54-0.54,1.05-0.79,1.66-0.18l2.08,2.08l2.31-2.32c0.54-0.54,0.4-1.86-0.21-2.47 l-3.05-3.05l1.46-1.46c0.54-0.54,0.65-1.45,0.04-2.05l-3.32-3.32c-0.61-0.61-1.51-0.49-2.05,0.04l-1.46,1.46l-2.68-2.68 c-0.61-0.61-1.67-0.48-2.21,0.05l-2.32,2.32l1.45,1.45c0.61,0.61,0.99,1.76,0.45,2.29l-2.91,2.91 c-0.54,0.54-1.63,0.11-2.24-0.51l-1.45-1.45l-2.69,2.69c-0.54,0.54-0.29,1.22,0.32,1.83l2.68,2.68l-1.83,1.83 c-0.54,0.54-0.59,1.38,0.02,1.99l3.32,3.32C103.02,263.62,103.86,263.57,104.4,263.03z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M110.81,266.06c-0.25,0-0.52-0.05-0.79-0.15c-0.66-0.24-1.19-0.7-1.44-0.96l-2.34-2.34l-1.12,1.12 c-0.45,0.45-1.04,0.71-1.67,0.71c-0.64-0.02-1.26-0.25-1.74-0.73l-3.32-3.32c-0.48-0.48-0.74-1.1-0.73-1.74 c0.01-0.62,0.26-1.21,0.72-1.66l1.12-1.12l-1.98-1.97c-1.31-1.32-1-2.57-0.32-3.25l3.4-3.4l2.15,2.15 c0.33,0.33,0.78,0.49,0.91,0.46l2.83-2.86c0-0.08-0.14-0.57-0.46-0.88l-2.15-2.15l3.02-3.02c0.87-0.87,2.57-1.1,3.62-0.05 l1.98,1.97l0.75-0.75c0.45-0.45,1.03-0.71,1.65-0.74c0.68-0.04,1.33,0.21,1.82,0.7l3.31,3.31c0.96,0.96,0.94,2.48-0.04,3.47 l-0.75,0.75l2.34,2.34c0.46,0.46,0.76,1.14,0.82,1.88c0.07,0.81-0.15,1.54-0.61,2.01l-3.02,3.02l-2.78-2.78 c-0.01-0.01-0.02-0.02-0.02-0.02c-0.05,0.04-0.12,0.1-0.23,0.2l-2.91,2.91c-0.07,0.07-0.12,0.12-0.15,0.17 c0.01,0.01,0.02,0.02,0.03,0.03l2.78,2.79l-3.4,3.4C111.74,265.88,111.3,266.06,110.81,266.06z M106.23,259.79l3.75,3.75 c0.31,0.3,0.61,0.46,0.76,0.51l1.91-1.9l-1.37-1.37c-0.44-0.44-0.67-0.92-0.67-1.43c0-0.72,0.45-1.25,0.79-1.59l2.91-2.91 c1.47-1.46,2.64-0.61,3.08-0.18l1.37,1.37l1.61-1.61c0.11-0.16,0.04-0.81-0.21-1.06l-3.75-3.75l2.17-2.17 c0.13-0.13,0.26-0.42,0.04-0.64l-3.32-3.32c-0.08-0.08-0.17-0.11-0.29-0.12c-0.12,0.01-0.25,0.07-0.35,0.16l-2.16,2.16 l-3.39-3.39c-0.19-0.18-0.62-0.12-0.79,0.05l-1.61,1.61l0.74,0.74c1,1,1.43,2.73,0.46,3.71l-2.91,2.91 c-0.98,0.97-2.66,0.49-3.66-0.51l-0.74-0.74l-1.98,1.98c0.01,0.03,0.08,0.18,0.32,0.42l3.39,3.39l-2.54,2.54 c-0.08,0.08-0.13,0.18-0.13,0.27c0,0.1,0.05,0.2,0.14,0.3l3.32,3.31c0.1,0.1,0.2,0.15,0.3,0.15c0.12,0.03,0.19-0.04,0.28-0.13 L106.23,259.79z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 81.1219,
    y1: 236.1355,
    x2: 104.9708,
    y2: 236.1355
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#944CE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1231,
    style: {
      stopColor: "#895AE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3554,
    style: {
      stopColor: "#6B7FEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6722,
    style: {
      stopColor: "#3BBAF4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#04FEFF"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M102.74,241.4l-1.86-1.86l3.12-3.12c0.61-0.61,1.32-1.7,0.78-2.24l-2.83-2.83l-2.25,2.24 c-0.61,0.61-0.79,0.41-1.33-0.12l-2.91-2.91c-0.54-0.54-1-0.98-0.39-1.59l2.25-2.25l-2.24-2.24c-0.54-0.54-1.86-0.06-2.47,0.55 l-3.12,3.12l-1.63-1.63c-0.54-0.54-1.54-0.9-2.15-0.29l-3.32,3.32c-0.61,0.61-0.41,1.78,0.13,2.31l1.63,1.63l-2.59,2.59 c-0.61,0.61-0.54,1.39-0.01,1.93l2.24,2.24l1.33-1.34c0.61-0.61,1.97-1.05,2.5-0.52l2.91,2.91c0.54,0.54-0.18,1.63-0.79,2.24 l-1.34,1.34l2.83,2.83c0.54,0.54,1.08,0.37,1.69-0.24l2.59-2.59l1.86,1.86c0.54,0.54,1.47,0.51,2.08-0.11l3.32-3.31 C103.4,242.7,103.28,241.93,102.74,241.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 80.1188,
    y1: 236.135,
    x2: 105.9699,
    y2: 236.135
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    style: {
      stopColor: "#FA9A35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    style: {
      stopColor: "#F67160"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6939,
    style: {
      stopColor: "#F35480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#F14193"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M91.93,249.03c-0.69,0-1.19-0.42-1.39-0.61l-3.54-3.54l2.04-2.04c0.37-0.37,0.59-0.75,0.66-0.95 l-2.73-2.73c-0.23-0.03-0.84,0.17-1.14,0.47l-2.04,2.04l-2.95-2.95c-0.97-0.97-0.96-2.37,0.01-3.34l1.89-1.88l-0.92-0.92 c-0.43-0.43-0.72-1.07-0.78-1.74c-0.07-0.77,0.16-1.5,0.65-1.99l3.31-3.31c0.51-0.51,1.25-0.72,2.01-0.56 c0.57,0.12,1.13,0.43,1.55,0.85l0.92,0.92l2.41-2.41c0.93-0.93,2.85-1.58,3.88-0.55l2.95,2.95l-2.84,2.85 c0.08,0.09,0.18,0.19,0.26,0.27l2.93,2.93c0.01,0.01,0.01,0.01,0.02,0.02l2.85-2.85l3.54,3.54c0.99,0.99,0.32,2.55-0.78,3.65 l-2.41,2.41l1.15,1.15c0.98,0.98,1,2.38,0.05,3.33l-3.32,3.32c-0.49,0.49-1.16,0.78-1.84,0.78l0,0c-0.63,0-1.22-0.24-1.65-0.67 l-1.15-1.15l-1.89,1.89C93.01,248.82,92.42,249.03,91.93,249.03z M89.83,244.87l2.12,2.12c0.06-0.04,0.15-0.11,0.28-0.24 l3.3-3.3l2.57,2.57c0.07,0.07,0.17,0.09,0.24,0.09l0,0c0.15,0,0.3-0.07,0.42-0.19l3.32-3.32c0.08-0.09,0.23-0.23-0.05-0.51 l-2.57-2.57l3.83-3.83c0.37-0.37,0.59-0.75,0.66-0.95l-2-2l-1.54,1.54c-0.31,0.31-0.74,0.67-1.32,0.67l0,0 c-0.63,0-1.02-0.39-1.4-0.77l-2.93-2.93c-0.48-0.48-1.7-1.7-0.39-3.01l1.54-1.54l-1.48-1.48c-0.22-0.04-0.8,0.17-1.11,0.49 l-3.83,3.83l-2.33-2.33c-0.15-0.15-0.36-0.26-0.54-0.3c-0.06-0.01-0.16-0.02-0.2,0.01l-3.32,3.32 c-0.06,0.06-0.09,0.21-0.08,0.38c0.02,0.24,0.12,0.43,0.21,0.52l2.33,2.33l-3.3,3.3c-0.13,0.13-0.23,0.29,0,0.52l1.54,1.54 l0.63-0.63c0.9-0.9,2.88-1.56,3.92-0.52l2.91,2.91c0.99,0.99,0.32,2.54-0.79,3.65L89.83,244.87z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M105.97,251.01l0.01,1.85l-10.67-10.67l-1.14,1.14l10.65,10.65l-1.78-0.03l-0.03,1.61l3.77,0.07 c0.22,0.01,0.43-0.08,0.58-0.23c0.15-0.15,0.24-0.36,0.24-0.58l-0.03-3.81L105.97,251.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M99.22,236.34l1.78,0.03l0.03-1.61l-3.77-0.07l-0.01,0c-0.21,0-0.42,0.08-0.57,0.23 c-0.15,0.15-0.24,0.36-0.24,0.58l0.03,3.81l1.61-0.01l-0.01-1.85l10.67,10.67l1.14-1.14L99.22,236.34z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 199.2183,
    y1: 103.2056,
    x2: 230.8218,
    y2: 103.2056
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#02247D"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M214.98,80.16c-7.55,0-15.76,5.84-15.76,15.59c0,14.83,15.8,30.51,15.8,30.51s15.8-15.93,15.8-30.51 C230.82,86,222.1,80.16,214.98,80.16z M218.9,102.43c-1.05,0.64-2.34,1.03-3.88,1.05c-2.15-0.03-3.83-0.79-5.03-1.95 c-4.43-4.11-2.74-13.59,5.07-13.59C223.5,87.95,224.78,99.06,218.9,102.43z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 198.2183,
    y1: 103.4126,
    x2: 231.8218,
    y2: 103.4126
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#02247D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    style: {
      stopColor: "#024792"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6157,
    style: {
      stopColor: "#039EC6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M215.03,127.67l-0.71-0.7c-0.66-0.65-16.1-16.14-16.1-31.22c0-10.25,8.7-16.59,16.76-16.59 c8.13,0,16.84,6.67,16.84,16.59c0,14.82-15.43,30.55-16.09,31.21L215.03,127.67z M214.98,81.16c-7.1,0-14.76,5.58-14.76,14.59 c0,12.47,11.76,25.82,14.8,29.06c3.03-3.28,14.81-16.81,14.81-29.06C229.82,86.23,221.2,81.16,214.98,81.16z M215.03,104.49 c-2.29-0.03-4.26-0.8-5.74-2.23c-2.59-2.4-3.45-6.57-2.06-10.12c1.28-3.25,4.2-5.2,7.82-5.2c4,0,7.12,2.37,8.14,6.2 c1.07,4.01-0.53,8.27-3.79,10.15C218.14,104.06,216.67,104.46,215.03,104.49z M215.05,88.95c-2.81,0-4.98,1.43-5.95,3.93 c-1.08,2.75-0.42,6.09,1.57,7.93c1.14,1.1,2.6,1.66,4.37,1.68c1.25-0.02,2.38-0.32,3.34-0.91l0.02-0.01 c2.83-1.62,3.58-5.21,2.86-7.91C220.48,90.71,218.16,88.95,215.05,88.95z"
  })))), /*#__PURE__*/React.createElement("g", null, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M128.04,110.43c-1.32,0-2.4-1.07-2.4-2.39c0-1.32,1.08-2.4,2.4-2.4c1.32,0,2.4,1.08,2.4,2.4 C130.43,109.36,129.36,110.43,128.04,110.43z M123.24,104.37c-0.36,0-0.67-0.13-0.93-0.38c-0.25-0.25-0.38-0.57-0.38-0.93 c0-0.35,0.14-0.68,0.38-0.93c1.53-1.53,3.57-2.37,5.74-2.37c2.17,0,4.2,0.84,5.72,2.37c0.25,0.25,0.39,0.57,0.39,0.93 c0,0.35-0.14,0.68-0.38,0.93c-0.25,0.25-0.58,0.38-0.93,0.38c-0.35,0-0.68-0.14-0.93-0.38c-1.04-1.03-2.41-1.6-3.87-1.6 c-1.46,0-2.84,0.57-3.87,1.6C123.92,104.23,123.59,104.37,123.24,104.37z M137.01,100.18c-0.39,0-0.75-0.15-1.03-0.43 c-2.12-2.12-4.94-3.29-7.94-3.29c-3,0-5.82,1.17-7.94,3.29c-0.28,0.28-0.64,0.43-1.03,0.43c-0.39,0-0.75-0.15-1.03-0.43 c-0.56-0.57-0.56-1.49,0-2.05c2.67-2.67,6.22-4.14,10.01-4.14c3.78,0,7.34,1.47,10,4.14c0.56,0.57,0.56,1.49,0,2.05 C137.76,100.04,137.4,100.18,137.01,100.18z M141.11,96.08c-0.39,0-0.75-0.15-1.03-0.43c-3.21-3.21-7.49-4.98-12.05-4.98 c-4.56,0-8.83,1.77-12.05,4.98c-0.27,0.28-0.64,0.43-1.03,0.43c-0.39,0-0.76-0.15-1.03-0.43c-0.57-0.57-0.56-1.49,0-2.05 c3.76-3.76,8.77-5.83,14.11-5.83c5.33,0,10.34,2.07,14.1,5.83c0.27,0.28,0.43,0.64,0.43,1.03c0,0.39-0.15,0.75-0.43,1.03 C141.87,95.93,141.5,96.08,141.11,96.08z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 112.509,
    y1: 99.0967,
    x2: 143.5689,
    y2: 99.0967
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M128.04,111.43c-1.87,0-3.4-1.52-3.4-3.39c0-1.88,1.52-3.4,3.4-3.4c1.87,0,3.4,1.53,3.4,3.4 C131.43,109.91,129.91,111.43,128.04,111.43z M128.04,106.64c-0.77,0-1.4,0.63-1.4,1.4c0,0.77,0.63,1.39,1.4,1.39 c0.77,0,1.4-0.62,1.4-1.39C129.43,107.27,128.81,106.64,128.04,106.64z M123.24,105.37c-0.62,0-1.18-0.23-1.63-0.67 c-0.44-0.45-0.68-1.03-0.68-1.64c0-0.61,0.24-1.19,0.67-1.63c1.73-1.72,4.01-2.67,6.45-2.67c2.44,0,4.72,0.95,6.43,2.67 c0.43,0.42,0.68,1,0.68,1.63c0,0.62-0.24,1.2-0.68,1.64c-0.86,0.86-2.39,0.87-3.27,0c-0.85-0.85-1.97-1.31-3.16-1.31 c-1.2,0-2.32,0.46-3.17,1.31C124.44,105.13,123.86,105.37,123.24,105.37z M128.04,100.76c-1.9,0-3.69,0.74-5.03,2.08 c-0.06,0.06-0.09,0.13-0.09,0.22c0,0.09,0.03,0.16,0.09,0.22c0.15,0.14,0.32,0.11,0.45-0.01c1.22-1.22,2.85-1.89,4.58-1.89 c1.72,0,3.35,0.67,4.58,1.89c0.12,0.12,0.33,0.12,0.44,0c0.06-0.06,0.09-0.13,0.09-0.22c0-0.09-0.03-0.15-0.09-0.21 C131.73,101.5,129.94,100.76,128.04,100.76z M137.01,101.18c-0.66,0-1.27-0.26-1.74-0.72c-1.93-1.93-4.5-2.99-7.23-2.99 c-2.74,0-5.31,1.06-7.24,2.99c-0.92,0.93-2.55,0.93-3.48,0c-0.95-0.96-0.95-2.51,0-3.46c2.86-2.86,6.66-4.43,10.71-4.43 c4.05,0,7.85,1.57,10.71,4.43c0.95,0.96,0.95,2.51,0,3.47C138.28,100.93,137.66,101.18,137.01,101.18z M128.04,95.47 c3.27,0,6.34,1.27,8.65,3.58c0.18,0.18,0.47,0.18,0.65,0c0.17-0.17,0.17-0.47,0-0.64c-2.48-2.48-5.78-3.84-9.29-3.84 c-3.52,0-6.82,1.37-9.3,3.85c-0.17,0.17-0.17,0.46,0,0.64c0.17,0.17,0.47,0.17,0.64,0C121.69,96.74,124.77,95.47,128.04,95.47z  M141.11,97.08c-0.66,0-1.28-0.26-1.74-0.73c-3.02-3.02-7.05-4.68-11.33-4.68c-4.29,0-8.32,1.67-11.34,4.69 c-0.92,0.93-2.55,0.93-3.48-0.01c-0.95-0.95-0.95-2.51,0.01-3.46c3.95-3.95,9.21-6.13,14.81-6.13c5.6,0,10.86,2.17,14.81,6.12 c0.46,0.46,0.72,1.08,0.72,1.73c0,0.66-0.26,1.27-0.72,1.74C142.39,96.82,141.77,97.08,141.11,97.08z M128.04,89.67 c4.82,0,9.35,1.87,12.75,5.27c0.18,0.18,0.47,0.18,0.64,0c0.09-0.09,0.14-0.2,0.14-0.32c0-0.12-0.05-0.23-0.13-0.32 c-3.57-3.57-8.33-5.54-13.4-5.54c-5.07,0-9.82,1.97-13.4,5.54c-0.18,0.18-0.18,0.46,0,0.64c0.18,0.18,0.47,0.18,0.64,0 C118.69,91.54,123.22,89.67,128.04,89.67z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 790.1329,
    y1: 388.4115,
    x2: 798.6209,
    y2: 403.7245,
    gradientTransform: "matrix(-0.9886 -0.1507 -0.1507 0.9886 1423.1377 108.5175)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#022894"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M559.35,371.02l9.23-9.09l23.97,24.33c2.49,2.52,2.46,6.58-0.07,9.07l-0.09,0.09 c-2.52,2.48-6.58,2.45-9.07-0.07L559.35,371.02z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 775.6532,
    y1: 395.1327,
    x2: 815.7463,
    y2: 395.1327,
    gradientTransform: "matrix(-0.9886 -0.1507 -0.1507 0.9886 1423.1377 108.5175)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M587.89,398.26c-1.92,0-3.83-0.74-5.28-2.21l-24.67-25.05l10.65-10.49l24.67,25.04 c1.39,1.41,2.15,3.28,2.13,5.26c-0.02,1.98-0.8,3.84-2.21,5.23l-0.09,0.09C591.65,397.55,589.77,398.26,587.89,398.26z  M560.77,371.03l23.27,23.62c2.09,2.13,5.53,2.15,7.66,0.06l0.09-0.09c1.04-1.02,1.61-2.38,1.62-3.82 c0.01-1.45-0.54-2.81-1.56-3.84l-23.27-23.62L560.77,371.03z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 790.1329,
    y1: 388.4115,
    x2: 798.6209,
    y2: 403.7245,
    gradientTransform: "matrix(-0.9886 -0.1507 -0.1507 0.9886 1423.1377 108.5175)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#022894"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M559.35,371.02l9.23-9.09l23.97,24.33c2.49,2.52,2.46,6.58-0.07,9.07l-0.09,0.09 c-2.52,2.48-6.58,2.45-9.07-0.07L559.35,371.02z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 775.6532,
    y1: 395.1327,
    x2: 815.7463,
    y2: 395.1327,
    gradientTransform: "matrix(-0.9886 -0.1507 -0.1507 0.9886 1423.1377 108.5175)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M587.89,398.26c-1.92,0-3.83-0.74-5.28-2.21l-24.67-25.05l10.65-10.49l24.67,25.04 c1.39,1.41,2.15,3.28,2.13,5.26c-0.02,1.98-0.8,3.84-2.21,5.23l-0.09,0.09C591.65,397.55,589.77,398.26,587.89,398.26z  M560.77,371.03l23.27,23.62c2.09,2.13,5.53,2.15,7.66,0.06l0.09-0.09c1.04-1.02,1.61-2.38,1.62-3.82 c0.01-1.45-0.54-2.81-1.56-3.84l-23.27-23.62L560.77,371.03z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M564.94,384.42l16.97-16.72L626,412.45c4.57,4.64,4.51,12.11-0.12,16.68l-0.17,0.17 c-4.64,4.57-12.11,4.51-16.68-0.13L564.94,384.42z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 736.4911,
    y1: 412.4971,
    x2: 807.8004,
    y2: 412.4971,
    gradientTransform: "matrix(-0.9886 -0.1507 -0.1507 0.9886 1423.1377 108.5175)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M617.43,433.68c-3.31,0-6.62-1.27-9.12-3.81l-44.08-44.75c-0.39-0.39-0.38-1.03,0.01-1.41l16.97-16.72 c0.39-0.39,1.03-0.38,1.41,0.01l44.09,44.75c4.95,5.03,4.89,13.14-0.13,18.09l-0.17,0.17 C623.92,432.46,620.67,433.68,617.43,433.68z M566.36,384.43l43.38,44.04c2.02,2.05,4.73,3.2,7.61,3.22c0.03,0,0.06,0,0.08,0 c2.85,0,5.54-1.1,7.57-3.1l0.17-0.17c4.24-4.18,4.29-11.02,0.11-15.26l-43.38-44.03L566.36,384.43z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 742.8948,
    y1: 436.1308,
    x2: 754.2964,
    y2: 436.1308,
    gradientTransform: "matrix(-0.9886 -0.1507 -0.1507 0.9886 1423.1377 108.5175)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M617.45,429.04c-0.42,0-0.84-0.03-1.26-0.1c-1.74-0.27-3.32-1.07-4.57-2.33l1.43-1.4 c0.94,0.95,2.13,1.56,3.44,1.76c1.94,0.29,3.85-0.32,5.25-1.7l1.4,1.43C621.6,428.22,619.57,429.04,617.45,429.04z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 758.1974,
    y1: 428.4742,
    x2: 769.1946,
    y2: 428.4742,
    gradientTransform: "matrix(-0.9886 -0.1507 -0.1507 0.9886 1423.1377 108.5175)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st53",
    points: "607.16,422.08 598.57,413.36 600,411.96 608.58,420.67  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 770.2562,
    y1: 421.17,
    x2: 776.6891,
    y2: 421.17,
    gradientTransform: "matrix(-0.9886 -0.1507 -0.1507 0.9886 1423.1377 108.5175)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st54",
    points: "596.59,411.35 592.01,406.7 593.43,405.29 598.02,409.95  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 790.1329,
    y1: 388.4115,
    x2: 798.6209,
    y2: 403.7245,
    gradientTransform: "matrix(-0.9886 -0.1507 -0.1507 0.9886 1423.1377 108.5175)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#022894"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M559.35,371.02l9.23-9.09l23.97,24.33c2.49,2.52,2.46,6.58-0.07,9.07l-0.09,0.09 c-2.52,2.48-6.58,2.45-9.07-0.07L559.35,371.02z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 775.6532,
    y1: 395.1327,
    x2: 815.7463,
    y2: 395.1327,
    gradientTransform: "matrix(-0.9886 -0.1507 -0.1507 0.9886 1423.1377 108.5175)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M587.89,398.26c-1.92,0-3.83-0.74-5.28-2.21l-24.67-25.05l10.65-10.49l24.67,25.04 c1.39,1.41,2.15,3.28,2.13,5.26c-0.02,1.98-0.8,3.84-2.21,5.23l-0.09,0.09C591.65,397.55,589.77,398.26,587.89,398.26z  M560.77,371.03l23.27,23.62c2.09,2.13,5.53,2.15,7.66,0.06l0.09-0.09c1.04-1.02,1.61-2.38,1.62-3.82 c0.01-1.45-0.54-2.81-1.56-3.84l-23.27-23.62L560.77,371.03z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M564.94,384.42l16.97-16.72L626,412.45c4.57,4.64,4.51,12.11-0.12,16.68l-0.17,0.17 c-4.64,4.57-12.11,4.51-16.68-0.13L564.94,384.42z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 736.4911,
    y1: 412.4971,
    x2: 807.8004,
    y2: 412.4971,
    gradientTransform: "matrix(-0.9886 -0.1507 -0.1507 0.9886 1423.1377 108.5175)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M617.43,433.68c-3.31,0-6.62-1.27-9.12-3.81l-44.08-44.75c-0.39-0.39-0.38-1.03,0.01-1.41l16.97-16.72 c0.39-0.39,1.03-0.38,1.41,0.01l44.09,44.75c4.95,5.03,4.89,13.14-0.13,18.09l-0.17,0.17 C623.92,432.46,620.67,433.68,617.43,433.68z M566.36,384.43l43.38,44.04c2.02,2.05,4.73,3.2,7.61,3.22c0.03,0,0.06,0,0.08,0 c2.85,0,5.54-1.1,7.57-3.1l0.17-0.17c4.24-4.18,4.29-11.02,0.11-15.26l-43.38-44.03L566.36,384.43z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 742.8948,
    y1: 436.1308,
    x2: 754.2964,
    y2: 436.1308,
    gradientTransform: "matrix(-0.9886 -0.1507 -0.1507 0.9886 1423.1377 108.5175)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M617.45,429.04c-0.42,0-0.84-0.03-1.26-0.1c-1.74-0.27-3.32-1.07-4.57-2.33l1.43-1.4 c0.94,0.95,2.13,1.56,3.44,1.76c1.94,0.29,3.85-0.32,5.25-1.7l1.4,1.43C621.6,428.22,619.57,429.04,617.45,429.04z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 758.1974,
    y1: 428.4742,
    x2: 769.1946,
    y2: 428.4742,
    gradientTransform: "matrix(-0.9886 -0.1507 -0.1507 0.9886 1423.1377 108.5175)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st59",
    points: "607.16,422.08 598.57,413.36 600,411.96 608.58,420.67  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 770.2562,
    y1: 421.17,
    x2: 776.6891,
    y2: 421.17,
    gradientTransform: "matrix(-0.9886 -0.1507 -0.1507 0.9886 1423.1377 108.5175)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "596.59,411.35 592.01,406.7 593.43,405.29 598.02,409.95  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M564.94,384.42l16.97-16.72L626,412.45c4.57,4.64,4.51,12.11-0.12,16.68l-0.17,0.17 c-4.64,4.57-12.11,4.51-16.68-0.13L564.94,384.42z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: 736.4911,
    y1: 412.4971,
    x2: 807.8004,
    y2: 412.4971,
    gradientTransform: "matrix(-0.9886 -0.1507 -0.1507 0.9886 1423.1377 108.5175)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M617.43,433.68c-3.31,0-6.62-1.27-9.12-3.81l-44.08-44.75c-0.39-0.39-0.38-1.03,0.01-1.41l16.97-16.72 c0.39-0.39,1.03-0.38,1.41,0.01l44.09,44.75c4.95,5.03,4.89,13.14-0.13,18.09l-0.17,0.17 C623.92,432.46,620.67,433.68,617.43,433.68z M566.36,384.43l43.38,44.04c2.02,2.05,4.73,3.2,7.61,3.22c0.03,0,0.06,0,0.08,0 c2.85,0,5.54-1.1,7.57-3.1l0.17-0.17c4.24-4.18,4.29-11.02,0.11-15.26l-43.38-44.03L566.36,384.43z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: 742.8948,
    y1: 436.1308,
    x2: 754.2964,
    y2: 436.1308,
    gradientTransform: "matrix(-0.9886 -0.1507 -0.1507 0.9886 1423.1377 108.5175)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M617.45,429.04c-0.42,0-0.84-0.03-1.26-0.1c-1.74-0.27-3.32-1.07-4.57-2.33l1.43-1.4 c0.94,0.95,2.13,1.56,3.44,1.76c1.94,0.29,3.85-0.32,5.25-1.7l1.4,1.43C621.6,428.22,619.57,429.04,617.45,429.04z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: 758.1974,
    y1: 428.4742,
    x2: 769.1946,
    y2: 428.4742,
    gradientTransform: "matrix(-0.9886 -0.1507 -0.1507 0.9886 1423.1377 108.5175)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st63",
    points: "607.16,422.08 598.57,413.36 600,411.96 608.58,420.67  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: 770.2562,
    y1: 421.17,
    x2: 776.6891,
    y2: 421.17,
    gradientTransform: "matrix(-0.9886 -0.1507 -0.1507 0.9886 1423.1377 108.5175)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st64",
    points: "596.59,411.35 592.01,406.7 593.43,405.29 598.02,409.95  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_65_",
    gradientUnits: "userSpaceOnUse",
    x1: 797.7461,
    y1: 355.5524,
    x2: 900.7087,
    y2: 355.5524,
    gradientTransform: "matrix(-0.9886 -0.1507 -0.1507 0.9886 1423.1377 108.5175)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#964AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03FFFF"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M478.55,331.57c-0.15,14.57,5.95,27.98,15.85,37.52c8.17,7.89,18.94,13.13,30.92,14.22 c1.38,0.12,2.81,0.19,4.18,0.19c7.06,0.08,13.9-1.25,20.34-3.92c1.04-0.44,2.08-0.93,3.09-1.43c2.84-1.43,5.54-3.11,8.09-5.04 c1.78-1.37,3.49-2.84,5.09-4.41c1.55-1.53,3.01-3.15,4.32-4.84c7.12-8.96,10.93-19.8,11.04-31.31 c0.12-13.75-5.11-26.71-14.76-36.54c-8.58-8.72-19.96-14.12-32.03-15.21c-1.39-0.11-2.8-0.21-4.22-0.21 c-13.74-0.12-26.77,5.17-36.58,14.83C484.1,305.03,478.64,317.87,478.55,331.57z M500.12,301.72 c8.15-8.03,18.9-12.38,30.27-12.29c1.16,0.03,2.35,0.08,3.49,0.18c10.01,0.91,19.41,5.39,26.49,12.62 c8,8.11,12.35,18.84,12.22,30.2c-0.11,11.3-4.61,21.92-12.7,29.92l-0.76,0.72c-1.42,1.31-2.91,2.52-4.45,3.61 c-7.4,5.26-16.08,8.01-25.1,7.94c-1.15-0.03-2.3-0.06-3.45-0.19c-12.25-1.11-22.96-7.46-30-16.7 c-5.54-7.29-8.8-16.37-8.71-26.09C487.55,320.3,492.05,309.68,500.12,301.72z M529.91,375.63c-0.11,0-0.22,0-0.34,0 c-1.2-0.03-2.36-0.06-3.55-0.19c-12.05-1.09-23.25-7.32-30.68-17.09c-5.92-7.79-9.01-17.03-8.92-26.7 c0.13-11.61,4.74-22.49,12.99-30.63l0,0c8.34-8.21,19.35-12.7,30.98-12.57c1.37,0.03,2.54,0.09,3.57,0.18 c10.23,0.93,19.86,5.51,27.12,12.92c8.19,8.3,12.63,19.28,12.51,30.92c-0.11,11.57-4.73,22.44-13,30.62l-0.77,0.73 c-1.47,1.35-3,2.59-4.56,3.7C547.77,372.82,539.02,375.63,529.91,375.63z M500.82,302.43c-7.87,7.77-12.28,18.15-12.4,29.23 c-0.08,9.23,2.86,18.04,8.51,25.47c7.1,9.32,17.77,15.27,29.29,16.31c1.13,0.13,2.24,0.16,3.38,0.18c0.11,0,0.21,0,0.32,0 c8.67,0,17.03-2.68,24.18-7.76c1.49-1.06,2.96-2.25,4.35-3.53l0.75-0.71c7.88-7.79,12.29-18.17,12.39-29.21 c0.12-11.1-4.11-21.57-11.93-29.49c-6.93-7.07-16.12-11.44-25.87-12.33c-0.98-0.09-2.11-0.14-3.42-0.17c-0.12,0-0.24,0-0.36,0 C519.04,290.43,508.69,294.69,500.82,302.43L500.82,302.43z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: 797.7461,
    y1: 355.5524,
    x2: 900.7087,
    y2: 355.5524,
    gradientTransform: "matrix(-0.9886 -0.1507 -0.1507 0.9886 1423.1377 108.5175)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#964AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03FFFF"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M478.55,331.57c-0.15,14.57,5.95,27.98,15.85,37.52c8.17,7.89,18.94,13.13,30.92,14.22 c1.38,0.12,2.81,0.19,4.18,0.19c7.06,0.08,13.9-1.25,20.34-3.92c1.04-0.44,2.08-0.93,3.09-1.43c2.84-1.43,5.54-3.11,8.09-5.04 c1.78-1.37,3.49-2.84,5.09-4.41c1.55-1.53,3.01-3.15,4.32-4.84c7.12-8.96,10.93-19.8,11.04-31.31 c0.12-13.75-5.11-26.71-14.76-36.54c-8.58-8.72-19.96-14.12-32.03-15.21c-1.39-0.11-2.8-0.21-4.22-0.21 c-13.74-0.12-26.77,5.17-36.58,14.83C484.1,305.03,478.64,317.87,478.55,331.57z M500.12,301.72 c8.15-8.03,18.9-12.38,30.27-12.29c1.16,0.03,2.35,0.08,3.49,0.18c10.01,0.91,19.41,5.39,26.49,12.62 c8,8.11,12.35,18.84,12.22,30.2c-0.11,11.3-4.61,21.92-12.7,29.92l-0.76,0.72c-1.42,1.31-2.91,2.52-4.45,3.61 c-7.4,5.26-16.08,8.01-25.1,7.94c-1.15-0.03-2.3-0.06-3.45-0.19c-12.25-1.11-22.96-7.46-30-16.7 c-5.54-7.29-8.8-16.37-8.71-26.09C487.55,320.3,492.05,309.68,500.12,301.72z M529.91,375.63c-0.11,0-0.22,0-0.34,0 c-1.2-0.03-2.36-0.06-3.55-0.19c-12.05-1.09-23.25-7.32-30.68-17.09c-5.92-7.79-9.01-17.03-8.92-26.7 c0.13-11.61,4.74-22.49,12.99-30.63l0,0c8.34-8.21,19.35-12.7,30.98-12.57c1.37,0.03,2.54,0.09,3.57,0.18 c10.23,0.93,19.86,5.51,27.12,12.92c8.19,8.3,12.63,19.28,12.51,30.92c-0.11,11.57-4.73,22.44-13,30.62l-0.77,0.73 c-1.47,1.35-3,2.59-4.56,3.7C547.77,372.82,539.02,375.63,529.91,375.63z M500.82,302.43c-7.87,7.77-12.28,18.15-12.4,29.23 c-0.08,9.23,2.86,18.04,8.51,25.47c7.1,9.32,17.77,15.27,29.29,16.31c1.13,0.13,2.24,0.16,3.38,0.18c0.11,0,0.21,0,0.32,0 c8.67,0,17.03-2.68,24.18-7.76c1.49-1.06,2.96-2.25,4.35-3.53l0.75-0.71c7.88-7.79,12.29-18.17,12.39-29.21 c0.12-11.1-4.11-21.57-11.93-29.49c-6.93-7.07-16.12-11.44-25.87-12.33c-0.98-0.09-2.11-0.14-3.42-0.17c-0.12,0-0.24,0-0.36,0 C519.04,290.43,508.69,294.69,500.82,302.43L500.82,302.43z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_67_",
    gradientUnits: "userSpaceOnUse",
    x1: 758.4171,
    y1: 1342.8954,
    x2: 777.4076,
    y2: 1342.8954,
    gradientTransform: "matrix(-1 0 0 -1 1283.3135 1565.2588)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M515.48,229.86h-0.15c-0.46,0-0.9-0.13-1.26-0.39c-0.43-0.3-0.73-0.74-0.86-1.24l-6.9-9.92 c-0.69-1.01-0.44-2.38,0.55-3.07c0.98-0.67,2.4-0.4,3.07,0.55l5.49,7.89l5.49-7.89c0.66-0.96,2.09-1.22,3.06-0.56 c1,0.69,1.25,2.07,0.56,3.07l-6.9,9.92c-0.13,0.5-0.44,0.94-0.87,1.24C516.37,229.73,515.93,229.86,515.48,229.86z  M515.46,227.86l0.02,1v-1c0.07,0,0.1-0.02,0.12-0.03c0.04-0.03,0.07-0.07,0.08-0.13l0.03-0.24l7.15-10.29 c0.06-0.09,0.04-0.22-0.05-0.29c-0.06-0.04-0.16-0.13-0.28,0.05l-7.13,10.26l-7.13-10.26c-0.12-0.18-0.22-0.09-0.28-0.05 c-0.09,0.06-0.11,0.19-0.04,0.29l7.15,10.28l0.03,0.24c0,0.04,0.02,0.1,0.08,0.14c0.01,0.01,0.04,0.03,0.12,0.03H515.46z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_68_",
    gradientUnits: "userSpaceOnUse",
    x1: 758.4152,
    y1: 1353.6914,
    x2: 777.4079,
    y2: 1353.6914,
    gradientTransform: "matrix(-1 0 0 -1 1283.3135 1565.2588)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M515.48,219.07h-0.16c-0.46,0-0.89-0.13-1.26-0.39c-0.43-0.3-0.73-0.74-0.86-1.24l-6.9-9.92 c-0.69-1-0.44-2.38,0.55-3.06c0.96-0.67,2.4-0.41,3.06,0.55l5.49,7.9l5.49-7.9c0.66-0.96,2.1-1.22,3.07-0.54 c0.48,0.33,0.8,0.83,0.91,1.41c0.1,0.58-0.02,1.17-0.36,1.65l-6.9,9.92c-0.13,0.5-0.44,0.94-0.87,1.24 C516.37,218.93,515.93,219.07,515.48,219.07z M515.46,217.07l0.02,1v-1c0.06,0,0.09-0.02,0.12-0.03 c0.06-0.04,0.07-0.1,0.08-0.13l0.03-0.24l7.15-10.29c0.04-0.06,0.04-0.11,0.03-0.15c-0.01-0.04-0.03-0.09-0.08-0.13 c-0.07-0.05-0.16-0.13-0.28,0.04l-7.13,10.27l-7.13-10.26c-0.12-0.18-0.22-0.09-0.28-0.05c-0.09,0.07-0.12,0.19-0.05,0.29 l7.15,10.28l0.03,0.24c0,0.04,0.02,0.1,0.08,0.14c0.01,0,0.04,0.03,0.11,0.03H515.46z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_69_",
    gradientUnits: "userSpaceOnUse",
    x1: 758.8793,
    y1: 1364.4877,
    x2: 777.8679,
    y2: 1364.4877,
    gradientTransform: "matrix(-1 0 0 -1 1283.3135 1565.2588)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M515.03,208.27h-0.17c-0.46,0-0.89-0.14-1.26-0.39c-0.42-0.29-0.73-0.73-0.86-1.24l-6.9-9.92 c-0.69-1.02-0.44-2.39,0.56-3.07c0.96-0.67,2.39-0.41,3.06,0.55l5.49,7.89l5.49-7.89c0.67-0.96,2.1-1.22,3.06-0.55 c1,0.69,1.25,2.07,0.55,3.07l-6.9,9.92c-0.13,0.5-0.44,0.95-0.87,1.24C515.91,208.13,515.48,208.27,515.03,208.27z  M515.01,206.27l0.02,1v-1c0.06,0,0.09-0.02,0.11-0.03c0.06-0.04,0.08-0.1,0.08-0.14l0.03-0.24l7.15-10.28 c0.06-0.09,0.04-0.22-0.05-0.28c-0.06-0.04-0.16-0.13-0.28,0.05l-7.13,10.26l-7.13-10.26c-0.12-0.18-0.22-0.09-0.28-0.05 c-0.1,0.07-0.12,0.2-0.05,0.3l7.15,10.27l0.03,0.24c0,0.03,0.02,0.1,0.08,0.13c0.03,0.02,0.06,0.03,0.11,0.03H515.01z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_70_",
    gradientUnits: "userSpaceOnUse",
    x1: 758.8771,
    y1: 1375.2845,
    x2: 777.8698,
    y2: 1375.2845,
    gradientTransform: "matrix(-1 0 0 -1 1283.3135 1565.2588)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st70",
    d: "M515.03,197.47h-0.18c-0.44,0-0.87-0.13-1.24-0.38c-0.44-0.31-0.74-0.75-0.88-1.25l-6.9-9.93 c-0.69-1-0.44-2.38,0.55-3.07c0.96-0.67,2.4-0.41,3.07,0.55l5.49,7.89l5.49-7.9c0.67-0.96,2.1-1.22,3.06-0.55 c0.48,0.34,0.81,0.84,0.91,1.42s-0.02,1.17-0.36,1.65l-6.9,9.93c-0.13,0.5-0.44,0.94-0.86,1.24 C515.9,197.34,515.47,197.47,515.03,197.47z M515.01,195.47l0.02,1v-1c0.04,0,0.08-0.01,0.12-0.04 c0.03-0.02,0.06-0.07,0.07-0.13l0.03-0.24l7.15-10.29c0.06-0.08,0.03-0.23-0.05-0.29c-0.06-0.04-0.16-0.13-0.28,0.05 l-7.13,10.26l-7.13-10.26c-0.12-0.18-0.22-0.09-0.28-0.05c-0.09,0.07-0.12,0.19-0.05,0.29l7.15,10.29l0.03,0.24 c0.01,0.04,0.03,0.1,0.08,0.14c0.02,0.01,0.06,0.03,0.1,0.03H515.01z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_71_",
    gradientUnits: "userSpaceOnUse",
    x1: 1146.9508,
    y1: 1392.6121,
    x2: 1165.9414,
    y2: 1392.6121,
    gradientTransform: "matrix(-1 0 0 -1 1283.3135 1565.2588)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M126.94,180.14h-0.15c-0.46,0-0.9-0.13-1.26-0.39c-0.43-0.3-0.73-0.74-0.86-1.24l-6.9-9.92 c-0.69-1.01-0.44-2.38,0.55-3.07c0.98-0.67,2.4-0.4,3.07,0.56l5.49,7.89l5.49-7.89c0.66-0.96,2.09-1.22,3.06-0.56 c1,0.69,1.25,2.07,0.56,3.07l-6.9,9.92c-0.13,0.5-0.44,0.94-0.87,1.24C127.83,180.01,127.4,180.14,126.94,180.14z  M126.92,178.14l0.02,1v-1c0.07,0,0.1-0.02,0.12-0.03c0.04-0.03,0.07-0.07,0.08-0.13l0.03-0.24l7.15-10.29 c0.06-0.09,0.04-0.22-0.05-0.29c-0.06-0.04-0.16-0.13-0.28,0.05l-7.13,10.26l-7.13-10.26c-0.13-0.18-0.22-0.09-0.28-0.05 c-0.09,0.06-0.11,0.19-0.04,0.29l7.15,10.28l0.03,0.24c0.01,0.04,0.02,0.1,0.08,0.14c0.01,0.01,0.04,0.03,0.12,0.03H126.92z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_72_",
    gradientUnits: "userSpaceOnUse",
    x1: 1146.9491,
    y1: 1403.4088,
    x2: 1165.9419,
    y2: 1403.4088,
    gradientTransform: "matrix(-1 0 0 -1 1283.3135 1565.2588)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M126.95,169.35h-0.16c-0.46,0-0.89-0.14-1.26-0.39c-0.43-0.3-0.73-0.74-0.86-1.24l-6.9-9.92 c-0.69-1-0.44-2.38,0.55-3.07c0.96-0.67,2.4-0.41,3.06,0.55l5.49,7.9l5.49-7.9c0.66-0.96,2.1-1.22,3.07-0.55 c0.48,0.33,0.8,0.83,0.91,1.41s-0.02,1.16-0.36,1.65l-6.9,9.92c-0.13,0.5-0.44,0.94-0.87,1.24 C127.83,169.21,127.4,169.35,126.95,169.35z M126.93,167.35l0.02,1v-1c0.06,0,0.09-0.02,0.12-0.03 c0.06-0.04,0.07-0.1,0.08-0.13l0.03-0.24l7.15-10.29c0.04-0.06,0.04-0.11,0.03-0.15c-0.01-0.04-0.03-0.09-0.08-0.13 c-0.07-0.05-0.16-0.13-0.28,0.04l-7.13,10.27l-7.13-10.26c-0.12-0.17-0.22-0.09-0.28-0.05c-0.09,0.07-0.12,0.19-0.05,0.29 l7.15,10.28l0.03,0.24c0,0.03,0.02,0.1,0.08,0.14c0.01,0.01,0.04,0.03,0.11,0.03L126.93,167.35z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_73_",
    gradientUnits: "userSpaceOnUse",
    x1: 1147.4132,
    y1: 1414.2045,
    x2: 1166.4019,
    y2: 1414.2045,
    gradientTransform: "matrix(-1 0 0 -1 1283.3135 1565.2588)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st73",
    d: "M126.49,158.55h-0.17c-0.46,0-0.89-0.14-1.26-0.39c-0.42-0.29-0.73-0.73-0.86-1.24l-6.9-9.92 c-0.69-1.01-0.44-2.39,0.56-3.07c0.96-0.67,2.39-0.41,3.06,0.55l5.49,7.9l5.48-7.9c0.67-0.96,2.1-1.22,3.06-0.55 c1,0.69,1.25,2.07,0.55,3.07l-6.9,9.92c-0.13,0.5-0.44,0.95-0.87,1.24C127.38,158.42,126.95,158.55,126.49,158.55z  M126.47,156.55l0.02,1v-1c0.06,0,0.09-0.02,0.11-0.03c0.06-0.04,0.08-0.1,0.08-0.14l0.03-0.24l7.15-10.28 c0.06-0.09,0.04-0.22-0.05-0.29c-0.06-0.04-0.16-0.13-0.28,0.05l-7.13,10.26l-7.13-10.26c-0.12-0.18-0.22-0.09-0.28-0.05 c-0.1,0.07-0.12,0.2-0.05,0.3l7.14,10.27l0.03,0.24c0,0.03,0.02,0.1,0.08,0.13c0.03,0.02,0.06,0.03,0.11,0.03L126.47,156.55z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_74_",
    gradientUnits: "userSpaceOnUse",
    x1: 1147.4111,
    y1: 1425.0017,
    x2: 1166.4036,
    y2: 1425.0017,
    gradientTransform: "matrix(-1 0 0 -1 1283.3135 1565.2588)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M126.5,147.75h-0.18c-0.44,0-0.87-0.13-1.24-0.38c-0.44-0.31-0.74-0.75-0.88-1.25l-6.9-9.93 c-0.69-1-0.44-2.38,0.55-3.07c0.96-0.67,2.4-0.41,3.07,0.55l5.49,7.89l5.48-7.89c0.67-0.96,2.1-1.22,3.06-0.55 c0.48,0.34,0.81,0.84,0.91,1.42c0.1,0.58-0.02,1.17-0.36,1.65l-6.9,9.93c-0.13,0.5-0.44,0.94-0.86,1.24 C127.36,147.62,126.94,147.75,126.5,147.75z M126.48,145.75l0.02,1v-1c0.04,0,0.08-0.01,0.12-0.04 c0.03-0.02,0.06-0.07,0.07-0.13l0.03-0.24l7.15-10.29c0.06-0.08,0.03-0.23-0.05-0.29c-0.06-0.04-0.16-0.13-0.28,0.05 l-7.13,10.26l-7.13-10.26c-0.12-0.18-0.22-0.09-0.28-0.05c-0.09,0.06-0.12,0.19-0.05,0.29l7.15,10.29l0.03,0.24 c0.01,0.04,0.02,0.1,0.08,0.14c0.02,0.01,0.06,0.03,0.1,0.03H126.48z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M651.1,279.75l-8.99,20.45l-0.15-8.45l-30.06,22.89c-0.17,0.13-0.34,0.28-0.52,0.43 c-0.67,0.56-1.5,1.27-2.57,1.52l-5.79,1.38c-11.98,2.85-18.6,4.43-22.29,5.3c-2.2,0.52-3.36,0.79-3.99,0.92l-4.33,3.78 l-23.35,20.39c-0.43,0.38-1.07,0.58-1.69,0.52c-0.35-0.04-0.67-0.15-0.94-0.33l-29.92-19.46c-2.07,1.99-14.52,11.75-25.27,20.42 c-0.69-1.48-1.28-3-1.77-4.56l25.12-20.08c0.39-0.5,1.08-1.12,1.99-1.03c0.27,0.03,0.54,0.12,0.78,0.27l30.04,19.55l24.15-21.09 l1.84-1.61c0.05-0.05,0.09-0.09,0.14-0.14c0.31-0.32,0.78-0.79,1.47-0.95l4.75-1.13l27.77-6.61l31.3-23.82l-8.78-1.34 L651.1,279.75z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_75_",
    gradientUnits: "userSpaceOnUse",
    x1: 488.466,
    y1: 314.632,
    x2: 652.0961,
    y2: 314.632
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC20B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F24B89"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M491.24,350.51c-0.08,0-0.15-0.01-0.23-0.03c-0.3-0.07-0.55-0.27-0.68-0.55c-0.7-1.51-1.32-3.09-1.82-4.68 c-0.12-0.39,0.01-0.82,0.33-1.08l25.03-20.01c0.78-0.95,1.78-1.41,2.8-1.31c0.44,0.05,0.85,0.19,1.21,0.42l29.42,19.15 l25.51-22.3c0.3-0.31,0.96-0.99,1.95-1.22l32.31-7.69l29.25-22.26l-6.45-0.99c-0.46-0.07-0.8-0.44-0.84-0.9 c-0.04-0.46,0.24-0.89,0.67-1.04l21.06-7.22c0.38-0.13,0.79-0.02,1.06,0.27c0.27,0.29,0.34,0.72,0.18,1.08l-8.99,20.45 c-0.19,0.43-0.64,0.67-1.11,0.58c-0.46-0.09-0.79-0.49-0.8-0.96l-0.11-6.47l-28.49,21.69c-0.11,0.08-0.22,0.18-0.33,0.28 l-0.15,0.12c-0.75,0.63-1.71,1.43-2.98,1.73l-15.43,3.68c-6.15,1.46-10.09,2.4-12.64,3.01c-1.94,0.46-3.08,0.72-3.76,0.87 l-27.48,24c-0.64,0.56-1.55,0.85-2.45,0.76c-0.54-0.06-1-0.23-1.4-0.49l-29.26-19.03c-2.03,1.78-7.22,5.92-13.61,11.02 c-3.59,2.87-7.46,5.96-11.14,8.92C491.68,350.43,491.46,350.51,491.24,350.51z M490.63,345.3c0.3,0.88,0.63,1.76,0.99,2.62 c3.37-2.71,6.87-5.5,10.13-8.11c6.83-5.45,12.73-10.16,14.06-11.44c0.34-0.32,0.85-0.37,1.24-0.12l29.92,19.46 c0.14,0.1,0.31,0.15,0.51,0.18c0.32,0.03,0.69-0.08,0.91-0.28l27.68-24.17c0.13-0.12,0.29-0.19,0.46-0.23 c0.63-0.13,1.78-0.4,3.96-0.91c2.55-0.6,6.5-1.54,12.64-3l15.44-3.68c0.82-0.19,1.5-0.77,2.11-1.27l0.19-0.16 c0.14-0.12,0.28-0.24,0.41-0.34l30.06-22.89c0.3-0.23,0.71-0.27,1.04-0.1c0.34,0.16,0.56,0.51,0.56,0.88l0.07,3.89l6.24-14.19 l-15.05,5.16l4.76,0.73c0.4,0.06,0.72,0.35,0.82,0.74c0.1,0.39-0.04,0.8-0.36,1.04l-31.3,23.82c-0.11,0.08-0.24,0.14-0.37,0.18 l-32.52,7.74c-0.4,0.09-0.69,0.37-0.98,0.67l-0.15,0.15l-1.89,1.66l-24.15,21.09c-0.34,0.3-0.83,0.33-1.2,0.09l-30.04-19.55 c-0.09-0.06-0.22-0.1-0.35-0.11c-0.46-0.06-0.88,0.39-1.09,0.65c-0.05,0.06-0.1,0.12-0.16,0.17L490.63,345.3z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M601.03,221.18h-38.4c-2.69,0-4.87,2.18-4.87,4.87v21.41c0,2.69,2.18,4.87,4.87,4.87h20.62v12l11.76-12 h6.02c2.69,0,4.87-2.18,4.87-4.87v-21.41C605.9,223.36,603.72,221.18,601.03,221.18z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_76_",
    gradientUnits: "userSpaceOnUse",
    x1: 556.7593,
    y1: 242.7554,
    x2: 606.9028,
    y2: 242.7554
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M583.25,265.33c-0.13,0-0.26-0.02-0.38-0.07c-0.38-0.15-0.62-0.52-0.62-0.93v-11h-19.62 c-3.24,0-5.87-2.63-5.87-5.87v-21.41c0-3.24,2.63-5.87,5.87-5.87h38.4c3.24,0,5.87,2.63,5.87,5.87v21.41 c0,3.24-2.63,5.87-5.87,5.87h-5.6l-11.47,11.7C583.77,265.23,583.51,265.33,583.25,265.33z M562.63,222.18 c-2.13,0-3.87,1.74-3.87,3.87v21.41c0,2.13,1.74,3.87,3.87,3.87h20.62c0.55,0,1,0.45,1,1v9.55l10.05-10.25 c0.19-0.19,0.45-0.3,0.71-0.3h6.02c2.13,0,3.87-1.74,3.87-3.87v-21.41c0-2.13-1.74-3.87-3.87-3.87H562.63z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M572.32,242.33l-5.57-5.57c-0.32-0.32-0.32-0.83,0-1.15l5.41-5.41l1.15,1.15l-4.84,4.84l4.99,4.99 L572.32,242.33z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_77_",
    gradientUnits: "userSpaceOnUse",
    x1: 565.5162,
    y1: 236.2642,
    x2: 574.4741,
    y2: 236.2642
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC20B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F24B89"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M572.32,243.33c-0.26,0-0.51-0.1-0.71-0.29l-5.57-5.57c-0.71-0.71-0.71-1.86,0-2.57l5.41-5.41 c0.39-0.39,1.02-0.39,1.41,0l1.15,1.15c0.19,0.19,0.29,0.44,0.29,0.71c0,0.27-0.11,0.52-0.29,0.71l-4.13,4.13l4.28,4.28 c0.19,0.19,0.29,0.44,0.29,0.71c0,0.27-0.11,0.52-0.29,0.71l-1.15,1.15C572.83,243.23,572.58,243.33,572.32,243.33z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M591.97,242.6l-1.15-1.15l5.11-5.11l-5.11-5.11l1.15-1.15l5.69,5.69c0.15,0.15,0.24,0.36,0.24,0.58 s-0.09,0.42-0.24,0.58L591.97,242.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_78_",
    gradientUnits: "userSpaceOnUse",
    x1: 589.8169,
    y1: 236.3422,
    x2: 598.895,
    y2: 236.3422
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC20B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F24B89"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M591.97,243.6L591.97,243.6c-0.27,0-0.52-0.11-0.71-0.29l-1.15-1.15c-0.39-0.39-0.39-1.02,0-1.41 l4.4-4.4l-4.4-4.4c-0.19-0.19-0.29-0.44-0.29-0.71c0-0.27,0.11-0.52,0.29-0.71l1.15-1.15c0.39-0.39,1.02-0.39,1.41,0 l5.69,5.69c0.34,0.35,0.53,0.8,0.53,1.28c0,0.48-0.19,0.94-0.53,1.28l-5.69,5.69C592.49,243.5,592.24,243.6,591.97,243.6z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 571.74,
    y: 235.45,
    transform: "matrix(0.406 -0.9139 0.9139 0.406 130.1216 672.725)",
    className: "st43",
    width: 21.65,
    height: 1.63
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_79_",
    gradientUnits: "userSpaceOnUse",
    x1: 576.4195,
    y1: 236.2643,
    x2: 588.7036,
    y2: 236.2643
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC20B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F24B89"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M578.91,247.49c-0.13,0-0.27-0.03-0.41-0.09l-1.49-0.66c-0.24-0.11-0.43-0.31-0.53-0.55 c-0.09-0.25-0.09-0.52,0.02-0.77l8.79-19.78c0.22-0.5,0.81-0.73,1.32-0.51l1.49,0.66c0.24,0.11,0.43,0.31,0.53,0.55 c0.09,0.25,0.09,0.52-0.02,0.77l-8.79,19.78C579.66,247.27,579.29,247.49,578.91,247.49z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M355.41,392.98c0-12.79,0-31.33,0-31.33h-36.35h-36.35c0,0,0,18.54,0,31.33 c0,10.13-31.05,18.74-43.93,21.87c-3.23,0.79-5.5,3.68-5.5,7v0.13c0,3.98,3.23,7.21,7.21,7.21h157.13 c3.98,0,7.21-3.23,7.21-7.21v-0.13c0-3.33-2.27-6.22-5.5-7C386.46,411.71,355.41,403.11,355.41,392.98z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_80_",
    gradientUnits: "userSpaceOnUse",
    x1: 232.2901,
    y1: 395.4175,
    x2: 405.8403,
    y2: 395.4175
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M397.63,430.19H240.5c-4.53,0-8.21-3.68-8.21-8.21v-0.13c0-3.8,2.58-7.08,6.26-7.97 c27.03-6.58,43.16-14.39,43.16-20.9v-32.33h74.69v32.33c0,6.51,16.14,14.33,43.16,20.9c3.69,0.9,6.26,4.18,6.26,7.97v0.13 C405.84,426.51,402.16,430.19,397.63,430.19z M283.72,362.65v30.33c0,10.42-28,18.78-44.69,22.84 c-2.79,0.68-4.74,3.16-4.74,6.03v0.13c0,3.42,2.78,6.21,6.21,6.21h157.13c3.42,0,6.21-2.79,6.21-6.21v-0.13 c0-2.87-1.95-5.35-4.74-6.03c-16.69-4.06-44.69-12.43-44.69-22.84v-30.33H283.72z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_81_",
    gradientUnits: "userSpaceOnUse",
    x1: 151.9341,
    y1: 367.1919,
    x2: 486.1958,
    y2: 367.1919
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#964AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0435,
    style: {
      stopColor: "#8955E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1911,
    style: {
      stopColor: "#6075E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3428,
    style: {
      stopColor: "#3E8FEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4972,
    style: {
      stopColor: "#24A4EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6554,
    style: {
      stopColor: "#12B2F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8197,
    style: {
      stopColor: "#07BBF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03BEF2"
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M151.93,355.66v12.95c0,5.58,4.42,10.11,9.87,10.11h314.52c5.45,0,9.87-4.52,9.87-10.11v-12.95H151.93z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M475.25,147.64H162.88c-5.42,0-9.81,4.49-9.81,10.04V355.9h331.98V157.68 C485.06,152.13,480.67,147.64,475.25,147.64z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_82_",
    gradientUnits: "userSpaceOnUse",
    x1: 152.0737,
    y1: 251.7697,
    x2: 486.0571,
    y2: 251.7697
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F41DB"
    }
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st82",
    d: "M486.06,356.9H152.07V157.68c0-6.09,4.85-11.04,10.81-11.04h312.37c5.96,0,10.81,4.95,10.81,11.04 V356.9z M154.07,354.9h329.98V157.68c0-4.98-3.95-9.04-8.81-9.04H162.88c-4.86,0-8.81,4.05-8.81,9.04V354.9z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_83_",
    gradientUnits: "userSpaceOnUse",
    x1: 169.0112,
    y1: 251.7107,
    x2: 469.5181,
    y2: 251.7107
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 169.01,
    y: 162.4,
    className: "st83",
    width: 300.51,
    height: 178.63
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_84_",
    gradientUnits: "userSpaceOnUse",
    x1: 168.0117,
    y1: 251.7107,
    x2: 470.5181,
    y2: 251.7107
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M470.52,342.03H168.01V161.4h302.51V342.03z M170.01,340.03h298.51V163.4H170.01V340.03z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_85_",
    gradientUnits: "userSpaceOnUse",
    x1: 370.1123,
    y1: 147.7824,
    x2: 392.666,
    y2: 147.7824
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M392.45,208.24c0.02-0.27,0.04-0.55,0.05-0.83l0.17-108.88c0.02-6.18-4.98-11.2-11.16-11.21 c-6.17-0.01-11.2,4.99-11.21,11.15l-0.18,108.89c0,0.29,0.02,0.56,0.05,0.84c3.62-0.65,7.34-1,11.15-0.99 C385.11,207.21,388.83,207.58,392.45,208.24z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_86_",
    gradientUnits: "userSpaceOnUse",
    x1: 369.1123,
    y1: 147.8757,
    x2: 393.666,
    y2: 147.8757
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M393.38,209.43l-1.11-0.2c-3.67-0.68-7.35-1.02-10.96-1.03c-3.66-0.03-7.34,0.32-10.97,0.98l-1.08,0.2 l-0.09-1.09c-0.03-0.3-0.05-0.6-0.05-0.91l0.18-108.9c0.01-6.71,5.48-12.15,12.19-12.15c0.01,0,0.02,0,0.03,0 c3.26,0.01,6.31,1.28,8.61,3.59c2.3,2.31,3.56,5.37,3.55,8.63l-0.17,108.88c0,0.23-0.02,0.45-0.03,0.67L393.38,209.43z  M381.17,206.2c0.05,0,0.09,0,0.14,0c3.35,0.01,6.77,0.29,10.18,0.86l0.17-108.53c0.01-2.72-1.05-5.29-2.97-7.21 c-1.92-1.93-4.48-2.99-7.2-3c-0.01,0-0.01,0-0.02,0c-5.61,0-10.17,4.55-10.19,10.16l-0.18,108.54 C374.45,206.48,377.83,206.2,381.17,206.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_87_",
    gradientUnits: "userSpaceOnUse",
    x1: 346.1396,
    y1: 257.4673,
    x2: 416.1808,
    y2: 257.4673
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#964AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03FFFF"
    }
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M387.51,223.03c-2.04-0.38-4.13-0.58-6.26-0.59c-2.14,0-4.24,0.19-6.27,0.56 c-16.36,2.92-28.79,17.18-28.83,34.38c-0.05,17.31,12.48,31.7,28.98,34.57c1.94,0.33,3.92,0.52,5.96,0.53 c2.03,0,4.02-0.18,5.96-0.5c16.51-2.79,29.11-17.13,29.15-34.44C416.22,240.35,403.85,226.03,387.51,223.03z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_88_",
    gradientUnits: "userSpaceOnUse",
    x1: 345.6396,
    y1: 257.4673,
    x2: 416.6808,
    y2: 257.4673
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F41DB"
    }
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M381.07,292.99c-2.01-0.01-4.04-0.2-6.04-0.54c-17.08-2.97-29.44-17.72-29.39-35.07 c0.04-17.2,12.34-31.86,29.25-34.88c2.08-0.38,4.22-0.57,6.36-0.57c2.1,0.01,4.24,0.21,6.35,0.59 c16.89,3.1,29.12,17.82,29.08,35.01c-0.04,17.35-12.47,32.04-29.56,34.93C385.1,292.82,383.07,292.99,381.07,292.99z  M381.24,222.94c-2.08,0-4.16,0.19-6.18,0.55c-16.43,2.93-28.38,17.18-28.42,33.89c-0.05,16.86,11.97,31.19,28.56,34.08 c1.94,0.33,3.92,0.51,5.88,0.52c1.94,0,3.91-0.17,5.87-0.5c16.61-2.81,28.69-17.08,28.73-33.94 c0.04-16.71-11.85-31.02-28.26-34.03l0,0C385.37,223.15,383.29,222.95,381.24,222.94z"
  }))), /*#__PURE__*/React.createElement("g", null, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M385.11,236.06c-1.27-0.23-2.57-0.36-3.89-0.37c-1.33,0-2.63,0.12-3.9,0.35 c-10.17,1.81-17.9,10.68-17.92,21.37c-0.03,10.76,7.76,19.71,18.01,21.49c1.2,0.21,2.44,0.32,3.7,0.33c1.26,0,2.5-0.11,3.7-0.31 c10.26-1.73,18.09-10.65,18.12-21.41C402.95,246.83,395.26,237.92,385.11,236.06z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_89_",
    gradientUnits: "userSpaceOnUse",
    x1: 358.391,
    y1: 257.4673,
    x2: 403.9293,
    y2: 257.4673
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F41DB"
    }
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M381.11,280.24c-1.29-0.01-2.59-0.12-3.87-0.35c-10.95-1.91-18.87-11.36-18.84-22.48 c0.03-11.02,7.91-20.42,18.75-22.35c1.33-0.24,2.7-0.36,4.07-0.36c1.35,0,2.72,0.13,4.08,0.38 c10.83,1.98,18.67,11.42,18.64,22.44c-0.03,11.12-8,20.54-18.95,22.39C383.69,280.13,382.39,280.24,381.11,280.24z  M381.21,236.7c-1.25,0-2.5,0.11-3.72,0.33c-9.89,1.76-17.08,10.34-17.1,20.39c-0.03,10.14,7.2,18.77,17.18,20.5 c1.17,0.2,2.37,0.31,3.54,0.32c1.16,0,2.35-0.1,3.53-0.3c9.99-1.69,17.26-10.28,17.29-20.42c0.02-10.05-7.13-18.66-17-20.47h0 C383.69,236.82,382.44,236.7,381.21,236.7z"
  }))), /*#__PURE__*/React.createElement("g", null, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M399.65,176.19l0.06-37.38c0.01-4.97-4.02-9.01-9-9.01h-18.58c-4.96,0-8.99,4.02-9,8.98l-0.06,37.38 c-0.01,4.97,4.02,9.01,9,9.01h18.58C395.62,185.18,399.64,181.16,399.65,176.19z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_90_",
    gradientUnits: "userSpaceOnUse",
    x1: 362.0762,
    y1: 157.4892,
    x2: 400.708,
    y2: 157.4892
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC20B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F24B89"
    }
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st90",
    d: "M390.65,186.18h-18.58c-2.67,0-5.19-1.04-7.07-2.93c-1.89-1.89-2.93-4.41-2.92-7.08l0.06-37.38 c0.01-5.5,4.49-9.98,10-9.98h18.58c2.67,0,5.19,1.04,7.07,2.93c1.89,1.89,2.93,4.41,2.92,7.08l-0.06,37.38l0,0 C400.64,181.7,396.16,186.18,390.65,186.18z M372.13,130.8c-4.4,0-7.99,3.58-8,7.98l-0.06,37.38c0,2.14,0.83,4.15,2.34,5.66 c1.51,1.51,3.52,2.35,5.66,2.35h18.58c4.4,0,7.99-3.58,8-7.99l0.06-37.38c0-2.14-0.83-4.15-2.34-5.66 c-1.51-1.51-3.52-2.35-5.66-2.35H372.13z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_91_",
    gradientUnits: "userSpaceOnUse",
    x1: 370.6055,
    y1: 140.4785,
    x2: 392.1787,
    y2: 140.4785
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M392.18,140.48c0,1.44-1.17,2.61-2.61,2.61h-16.35c-1.44,0-2.61-1.17-2.61-2.61l0,0 c0-1.44,1.17-2.61,2.61-2.61h16.35C391.01,137.87,392.18,139.04,392.18,140.48L392.18,140.48z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_92_",
    gradientUnits: "userSpaceOnUse",
    x1: 369.6055,
    y1: 140.4785,
    x2: 393.1787,
    y2: 140.4785
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st92",
    d: "M389.57,144.09h-16.35c-1.99,0-3.61-1.62-3.61-3.61s1.62-3.61,3.61-3.61h16.35c1.99,0,3.61,1.62,3.61,3.61 S391.56,144.09,389.57,144.09z M373.22,138.87c-0.89,0-1.61,0.72-1.61,1.61c0,0.89,0.72,1.61,1.61,1.61h16.35 c0.89,0,1.61-0.72,1.61-1.61c0-0.89-0.72-1.61-1.61-1.61H373.22z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_93_",
    gradientUnits: "userSpaceOnUse",
    x1: 370.6055,
    y1: 157.5459,
    x2: 392.1787,
    y2: 157.5459
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M392.18,157.55c0,1.44-1.17,2.61-2.61,2.61h-16.35c-1.44,0-2.61-1.17-2.61-2.61l0,0 c0-1.44,1.17-2.61,2.61-2.61h16.35C391.01,154.93,392.18,156.1,392.18,157.55L392.18,157.55z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_94_",
    gradientUnits: "userSpaceOnUse",
    x1: 369.6055,
    y1: 157.5459,
    x2: 393.1787,
    y2: 157.5459
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M389.57,161.16h-16.35c-1.99,0-3.61-1.62-3.61-3.61s1.62-3.61,3.61-3.61h16.35c1.99,0,3.61,1.62,3.61,3.61 S391.56,161.16,389.57,161.16z M373.22,155.93c-0.89,0-1.61,0.72-1.61,1.61c0,0.89,0.72,1.61,1.61,1.61h16.35 c0.89,0,1.61-0.72,1.61-1.61c0-0.89-0.72-1.61-1.61-1.61H373.22z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_95_",
    gradientUnits: "userSpaceOnUse",
    x1: 370.6055,
    y1: 174.6133,
    x2: 392.1787,
    y2: 174.6133
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M392.18,174.61c0,1.44-1.17,2.61-2.61,2.61h-16.35c-1.44,0-2.61-1.17-2.61-2.61l0,0 c0-1.44,1.17-2.61,2.61-2.61h16.35C391.01,172,392.18,173.17,392.18,174.61L392.18,174.61z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_96_",
    gradientUnits: "userSpaceOnUse",
    x1: 369.6055,
    y1: 174.6133,
    x2: 393.1787,
    y2: 174.6133
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M389.57,178.23h-16.35c-1.99,0-3.61-1.62-3.61-3.61s1.62-3.61,3.61-3.61h16.35c1.99,0,3.61,1.62,3.61,3.61 S391.56,178.23,389.57,178.23z M373.22,173c-0.89,0-1.61,0.72-1.61,1.61c0,0.89,0.72,1.61,1.61,1.61h16.35 c0.89,0,1.61-0.72,1.61-1.61c0-0.89-0.72-1.61-1.61-1.61H373.22z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_460_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M431.68,278.09l9.24,1.91l4.04-19.51l-9.24-1.91c0.16-7.78-1.35-15.33-4.25-22.24l7.89-5.19 l-10.94-16.65l-7.89,5.19c-4.08-4.26-8.89-7.88-14.27-10.66c-1.39-0.72-2.83-1.39-4.3-1.99c-0.05-0.03-0.12-0.04-0.18-0.07 l1.93-9.25l-19.51-4.04l-1.92,9.25c-2.04-0.05-4.07,0.03-6.08,0.21c-5.64,0.5-11.08,1.88-16.18,4.04l-5.19-7.89l-16.64,10.94 l5.18,7.88c-5.41,5.19-9.79,11.53-12.73,18.74l-9.24-1.91l-4.04,19.51l9.24,1.91c-0.16,7.78,1.33,15.34,4.25,22.25l-7.88,5.18 l10.93,16.65l7.9-5.19c5.19,5.42,11.53,9.8,18.74,12.73l-1.92,9.25l19.5,4.03l1.91-9.24c2.06,0.04,4.08-0.03,6.09-0.21 c5.63-0.51,11.08-1.9,16.17-4.04l5.19,7.89l16.64-10.95l-5.18-7.89C424.36,291.64,428.74,285.3,431.68,278.09z M384.83,297.6 c-3.86,0.35-7.84,0.15-11.82-0.68c-21.79-4.5-35.8-25.82-31.3-47.61c3.69-17.8,18.58-30.4,35.79-31.97 c3.86-0.35,7.84-0.15,11.82,0.68c2.3,0.48,4.5,1.13,6.62,1.97c1.48,0.57,2.92,1.24,4.3,1.98 c15.3,8.22,24.08,25.77,20.37,43.66C416.93,283.43,402.04,296.03,384.83,297.6z M381.19,298.76c-2.81,0-5.62-0.29-8.39-0.87 c-22.29-4.61-36.68-26.49-32.07-48.79c3.72-17.94,18.46-31.1,36.68-32.77c4.05-0.37,8.13-0.14,12.12,0.7 c2.35,0.49,4.63,1.17,6.78,2.02c1.49,0.57,2.97,1.26,4.41,2.03c15.97,8.58,24.55,26.98,20.88,44.74 c-3.71,17.93-18.45,31.09-36.68,32.76C383.68,298.71,382.43,298.76,381.19,298.76z M381.13,218.17 c-1.18,0-2.37,0.05-3.55,0.16c-17.34,1.58-31.37,14.11-34.9,31.18c-4.38,21.21,9.31,42.04,30.52,46.42 c3.8,0.79,7.68,1.02,11.53,0.66l0,0c17.34-1.58,31.37-14.11,34.9-31.17c3.5-16.91-4.67-34.41-19.87-42.58 c-1.36-0.73-2.77-1.38-4.19-1.93c-2.05-0.81-4.23-1.46-6.46-1.93C386.48,218.45,383.81,218.17,381.13,218.17z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_97_",
    gradientUnits: "userSpaceOnUse",
    x1: 187.4487,
    y1: 256.7271,
    x2: 246.5913,
    y2: 256.7271
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#964AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03FFFF"
    }
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M187.45,269.4l14.29-1.39c0.86,4.8,2.6,8.32,5.23,10.57c2.63,2.25,6.18,3.37,10.64,3.37 c4.73,0,8.29-1,10.69-3c2.4-2,3.6-4.34,3.6-7.02c0-1.72-0.5-3.18-1.51-4.39c-1.01-1.21-2.77-2.26-5.28-3.15 c-1.72-0.6-5.64-1.65-11.76-3.18c-7.87-1.95-13.4-4.35-16.57-7.2c-4.46-4-6.7-8.88-6.7-14.64c0-3.7,1.05-7.17,3.15-10.39 c2.1-3.22,5.13-5.68,9.08-7.37c3.95-1.69,8.72-2.53,14.31-2.53c9.13,0,16,2,20.61,6c4.61,4,7.04,9.35,7.27,16.03l-14.69,0.64 c-0.63-3.74-1.98-6.43-4.04-8.06c-2.07-1.64-5.17-2.46-9.3-2.46c-4.27,0-7.61,0.88-10.02,2.63c-1.55,1.12-2.33,2.63-2.33,4.51 c0,1.72,0.73,3.19,2.18,4.42c1.85,1.56,6.35,3.18,13.5,4.86c7.14,1.69,12.43,3.43,15.85,5.23c3.42,1.8,6.1,4.27,8.04,7.39 c1.94,3.12,2.9,6.99,2.9,11.59c0,4.17-1.16,8.07-3.47,11.71c-2.32,3.64-5.59,6.34-9.82,8.11c-4.23,1.77-9.51,2.65-15.83,2.65 c-9.2,0-16.26-2.12-21.19-6.38C191.35,283.73,188.41,277.54,187.45,269.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_98_",
    gradientUnits: "userSpaceOnUse",
    x1: 186.8926,
    y1: 256.7271,
    x2: 247.0913,
    y2: 256.7271
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F41DB"
    }
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "M217.47,294.86c-9.28,0-16.51-2.19-21.51-6.5c-5-4.31-8.03-10.67-9-18.9l-0.06-0.51l15.26-1.48l0.08,0.45 c0.83,4.66,2.54,8.12,5.07,10.28c2.52,2.16,5.99,3.25,10.32,3.25c4.59,0,8.08-0.97,10.37-2.88c2.27-1.89,3.42-4.12,3.42-6.64 c0-1.59-0.47-2.96-1.4-4.07c-0.95-1.13-2.65-2.14-5.07-3c-1.68-0.58-5.63-1.65-11.71-3.16c-7.92-1.96-13.56-4.42-16.79-7.31 c-4.55-4.08-6.86-9.13-6.86-15.01c0-3.79,1.09-7.38,3.23-10.67c2.15-3.29,5.28-5.84,9.3-7.55c3.99-1.71,8.88-2.57,14.51-2.57 c9.21,0,16.26,2.06,20.94,6.12c4.7,4.08,7.21,9.59,7.44,16.39l0.02,0.49l-15.62,0.69l-0.07-0.44c-0.6-3.59-1.9-6.2-3.86-7.75 c-1.97-1.56-4.99-2.35-8.99-2.35c-4.14,0-7.41,0.85-9.73,2.54c-1.43,1.04-2.13,2.38-2.13,4.11c0,1.58,0.66,2.9,2,4.03 c1.78,1.5,6.25,3.1,13.29,4.76c7.15,1.69,12.53,3.46,15.97,5.28c3.49,1.84,6.26,4.38,8.23,7.57c1.98,3.19,2.98,7.18,2.98,11.85 c0,4.24-1.19,8.27-3.55,11.98c-2.36,3.71-5.74,6.5-10.05,8.3C229.21,293.95,223.82,294.86,217.47,294.86z M188.01,269.85 c1,7.72,3.89,13.7,8.6,17.75c4.81,4.15,11.83,6.25,20.86,6.25c6.22,0,11.48-0.88,15.63-2.62c4.12-1.72,7.35-4.38,9.6-7.92 c2.25-3.54,3.39-7.39,3.39-11.44c0-4.48-0.95-8.29-2.83-11.32c-1.88-3.03-4.52-5.46-7.85-7.21c-3.37-1.77-8.66-3.52-15.73-5.19 c-7.29-1.72-11.77-3.35-13.7-4.97c-1.57-1.32-2.36-2.93-2.36-4.8c0-2.04,0.85-3.7,2.54-4.92c2.49-1.81,5.96-2.72,10.32-2.72 c4.23,0,7.46,0.86,9.61,2.56c2.08,1.64,3.47,4.31,4.15,7.94l13.75-0.6c-0.33-6.28-2.71-11.38-7.08-15.17 c-4.5-3.9-11.32-5.88-20.29-5.88c-5.5,0-10.25,0.84-14.12,2.49c-3.84,1.64-6.82,4.05-8.86,7.18c-2.04,3.13-3.07,6.53-3.07,10.12 c0,5.58,2.2,10.38,6.53,14.27c3.1,2.78,8.6,5.16,16.36,7.08c6.2,1.54,10.06,2.59,11.8,3.19c2.59,0.92,4.44,2.03,5.5,3.3 c1.08,1.29,1.63,2.88,1.63,4.71c0,2.82-1.27,5.31-3.78,7.4c-2.48,2.07-6.18,3.12-11.01,3.12c-4.57,0-8.26-1.17-10.97-3.49 c-2.62-2.24-4.41-5.74-5.32-10.41L188.01,269.85z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_99_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.9463,
    y1: 256.7026,
    x2: 314.2676,
    y2: 256.7026
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#964AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03FFFF"
    }
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M258.95,293.07v-72.74h53.93v12.3h-39.25v16.12h36.52v12.25h-36.52v19.8h40.64v12.26H258.95z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_100_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.4463,
    y1: 256.7026,
    x2: 314.7676,
    y2: 256.7026
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F41DB"
    }
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M314.77,293.57h-56.32v-73.74h54.93v13.3h-39.25v15.12h36.52v13.25h-36.52v18.8h40.64V293.57z  M259.45,292.57h54.32v-11.26h-40.64v-20.8h36.52v-11.25h-36.52v-17.12h39.25v-11.3h-52.93V292.57z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_101_",
    gradientUnits: "userSpaceOnUse",
    x1: 130.6421,
    y1: 306.5796,
    x2: 156.8784,
    y2: 306.5796
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#964AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03FFFF"
    }
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 130.64,
    y: 298.73,
    className: "st101",
    width: 26.24,
    height: 15.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_102_",
    gradientUnits: "userSpaceOnUse",
    x1: 129.6421,
    y1: 306.5796,
    x2: 157.8784,
    y2: 306.5796
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F41DB"
    }
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M157.88,315.43h-28.24v-17.7h28.24V315.43z M131.64,313.43h24.24v-13.7h-24.24V313.43z"
  }))), /*#__PURE__*/React.createElement("g", null, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M158.31,301.36h-29.1c-3.79,0-6.87-3.08-6.87-6.87v-1.96c0-3.79,3.08-6.87,6.87-6.87h29.1 c3.79,0,6.87,3.08,6.87,6.87v1.96C165.18,298.28,162.1,301.36,158.31,301.36z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_103_",
    gradientUnits: "userSpaceOnUse",
    x1: 121.3399,
    y1: 293.5054,
    x2: 166.1807,
    y2: 293.5054
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M158.31,302.36h-29.1c-4.34,0-7.87-3.53-7.87-7.87v-1.96c0-4.34,3.53-7.87,7.87-7.87h29.1 c4.34,0,7.87,3.53,7.87,7.87v1.96C166.18,298.82,162.65,302.36,158.31,302.36z M129.21,286.65c-3.24,0-5.87,2.63-5.87,5.87 v1.96c0,3.24,2.63,5.87,5.87,5.87h29.1c3.24,0,5.87-2.63,5.87-5.87v-1.96c0-3.24-2.63-5.87-5.87-5.87H129.21z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_104_",
    gradientUnits: "userSpaceOnUse",
    x1: 181.1079,
    y1: 326.2924,
    x2: 198.9829,
    y2: 326.2924
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#964AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03FFFF"
    }
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st104",
    points: "192.44,335.15 181.11,324.21 187.65,317.43 198.98,328.37  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_105_",
    gradientUnits: "userSpaceOnUse",
    x1: 179.6939,
    y1: 326.2925,
    x2: 200.397,
    y2: 326.2925
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F41DB"
    }
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M192.46,336.57l-12.77-12.33l7.94-8.22l12.77,12.33L192.46,336.57z M182.52,324.19l9.89,9.55l5.16-5.34 l-9.89-9.55L182.52,324.19z"
  }))), /*#__PURE__*/React.createElement("g", null, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M198.51,330.1l-12.57-12.13c-1.64-1.58-1.68-4.19-0.1-5.83l0.82-0.85c1.58-1.64,4.19-1.68,5.83-0.1 l12.57,12.13c1.64,1.58,1.68,4.19,0.1,5.83l-0.82,0.85C202.76,331.64,200.14,331.69,198.51,330.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_106_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.6818,
    y1: 320.6444,
    x2: 207.3099,
    y2: 320.6444
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M201.37,332.26c-1.34,0-2.59-0.51-3.56-1.44l-12.57-12.13c-0.98-0.95-1.54-2.23-1.56-3.6 c-0.02-1.37,0.49-2.66,1.44-3.65l0.82-0.85c0.95-0.99,2.23-1.54,3.6-1.56c1.34-0.06,2.66,0.48,3.65,1.44l12.57,12.13 c2.03,1.96,2.09,5.21,0.13,7.25l-0.82,0.85c-0.95,0.99-2.23,1.54-3.6,1.56C201.43,332.26,201.4,332.26,201.37,332.26z  M189.62,311.03c-0.02,0-0.04,0-0.06,0c-0.83,0.01-1.61,0.35-2.19,0.95l-0.82,0.85c-0.58,0.6-0.89,1.39-0.88,2.22 c0.01,0.84,0.35,1.61,0.95,2.19l12.57,12.13c0,0,0,0,0,0c0.6,0.58,1.38,0.88,2.22,0.88c0.83-0.01,1.61-0.35,2.19-0.95 l0.82-0.85c1.2-1.24,1.16-3.22-0.08-4.42l-12.57-12.13C191.21,311.34,190.44,311.03,189.62,311.03z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_107_",
    gradientUnits: "userSpaceOnUse",
    x1: 87.4155,
    y1: 326.2924,
    x2: 105.2905,
    y2: 326.2924
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#964AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03FFFF"
    }
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st107",
    points: "93.96,335.15 105.29,324.21 98.74,317.43 87.42,328.37  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_108_",
    gradientUnits: "userSpaceOnUse",
    x1: 86.0015,
    y1: 326.2925,
    x2: 106.7046,
    y2: 326.2925
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F41DB"
    }
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M93.94,336.57L86,328.35l12.77-12.33l7.94,8.22L93.94,336.57z M88.83,328.4l5.16,5.34l9.89-9.55 l-5.16-5.34L88.83,328.4z"
  }))), /*#__PURE__*/React.createElement("g", null, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M87.89,330.1l12.57-12.13c1.64-1.58,1.68-4.19,0.1-5.83l-0.82-0.85c-1.58-1.64-4.19-1.68-5.83-0.1 l-12.57,12.13c-1.64,1.58-1.68,4.19-0.1,5.83l0.82,0.85C83.64,331.64,86.25,331.69,87.89,330.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_109_",
    gradientUnits: "userSpaceOnUse",
    x1: 79.0856,
    y1: 320.6456,
    x2: 102.7166,
    y2: 320.6456
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M85.03,332.26c-0.03,0-0.06,0-0.09,0c-1.37-0.02-2.65-0.58-3.6-1.56l-0.82-0.85 c-0.95-0.98-1.46-2.28-1.44-3.65c0.02-1.37,0.58-2.65,1.56-3.6l12.56-12.13c0.98-0.95,2.26-1.48,3.65-1.44 c1.37,0.02,2.65,0.58,3.6,1.56l0.82,0.85c0.95,0.98,1.46,2.28,1.44,3.65c-0.02,1.37-0.58,2.65-1.56,3.6l-12.57,12.13 C87.62,331.75,86.36,332.26,85.03,332.26z M96.77,311.03c-0.81,0-1.58,0.31-2.17,0.88l-12.57,12.13 c-1.24,1.2-1.27,3.18-0.08,4.42l0.82,0.85c0.58,0.6,1.36,0.94,2.19,0.95c0.85,0.02,1.62-0.3,2.22-0.88l0,0l12.57-12.13 c0.6-0.58,0.94-1.36,0.95-2.19c0.01-0.83-0.3-1.62-0.88-2.22l-0.82-0.85c-0.58-0.6-1.36-0.94-2.19-0.95 C96.81,311.03,96.79,311.03,96.77,311.03z"
  })))), /*#__PURE__*/React.createElement("g", null, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M207.67,374.17c0,35.29-28.61,63.9-63.91,63.9c-35.29,0-63.9-28.61-63.9-63.9 c0-35.29,28.61-63.9,63.9-63.9C179.05,310.26,207.67,338.88,207.67,374.17z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_110_",
    gradientUnits: "userSpaceOnUse",
    x1: 78.856,
    y1: 374.1685,
    x2: 208.6651,
    y2: 374.1685
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st110",
    d: "M143.76,439.07c-35.79,0-64.9-29.12-64.9-64.9c0-35.79,29.12-64.9,64.9-64.9 c35.79,0,64.91,29.12,64.91,64.9C208.67,409.96,179.55,439.07,143.76,439.07z M143.76,311.26c-34.69,0-62.9,28.22-62.9,62.9 c0,34.69,28.22,62.9,62.9,62.9c34.69,0,62.91-28.22,62.91-62.9C206.67,339.48,178.45,311.26,143.76,311.26z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_111_",
    gradientUnits: "userSpaceOnUse",
    x1: 87.7469,
    y1: 374.2579,
    x2: 199.6,
    y2: 374.2579
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#964AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03FFFF"
    }
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M198.72,384.15c2.94-16.44-1.48-34.01-13.53-47.36c-20.69-22.93-56.06-24.75-78.99-4.05 c-10.23,9.23-16.25,21.38-17.95,34.04c-2.11,15.73,2.44,32.25,13.9,44.95c20.69,22.93,56.06,24.74,78.99,4.05 C190.72,407.14,196.61,395.93,198.72,384.15z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_112_",
    gradientUnits: "userSpaceOnUse",
    x1: 86.7459,
    y1: 374.2446,
    x2: 200.6145,
    y2: 374.2446
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F41DB"
    }
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st112",
    d: "M143.7,431.16c-15.56,0-31.07-6.32-42.29-18.76c-11.23-12.45-16.39-29.12-14.15-45.76 c1.79-13.33,8.28-25.63,18.27-34.65c11.29-10.19,25.87-15.36,41.06-14.59c15.19,0.78,29.16,7.43,39.35,18.71 c11.88,13.16,16.9,30.73,13.77,48.21l0,0c-2.24,12.53-8.43,23.66-17.89,32.2C170.95,426.33,157.3,431.16,143.7,431.16z  M143.61,319.33c-13.61,0-26.56,4.97-36.73,14.15c-9.64,8.7-15.9,20.57-17.63,33.43c-2.16,16.05,2.82,32.14,13.65,44.15 c20.29,22.48,55.09,24.27,77.58,3.98c9.13-8.24,15.1-18.98,17.26-31.07l0,0c3.02-16.86-1.83-33.82-13.29-46.51 c-9.83-10.89-23.31-17.3-37.97-18.06C145.52,319.35,144.56,319.33,143.61,319.33z"
  }))), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M198.45,374.27c-0.01-12.61-4.28-24.22-11.45-33.46c-10.01-12.9-25.66-21.21-43.25-21.21 c-0.09,0-0.17,0.01-0.26,0.01v54.67H198.45z"
  })), /*#__PURE__*/React.createElement("g", null, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M165.86,407.39l-18.83-31.21c0.19-0.46,0.3-0.97,0.3-1.51v-0.27c0-2.18-1.77-3.95-3.95-3.95 c-2.18,0-3.95,1.77-3.95,3.95v0.27c0,2.18,1.77,3.95,3.95,3.95c0.25,0,0.5-0.03,0.74-0.07l18.55,30.74 c0.52,0.88,1.66,1.17,2.54,0.64C166.1,409.4,166.39,408.27,165.86,407.39z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_113_",
    gradientUnits: "userSpaceOnUse",
    x1: 138.4385,
    y1: 390.3218,
    x2: 167.1277,
    y2: 390.3218
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC20B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F24B89"
    }
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M164.28,411.19c-0.23,0-0.47-0.03-0.71-0.09c-0.74-0.19-1.36-0.65-1.75-1.3l-18.21-30.18 c-2.83,0.1-5.17-2.14-5.17-4.95v-0.27c0-2.73,2.22-4.95,4.95-4.95c2.73,0,4.95,2.22,4.95,4.95v0.27c0,0.48-0.07,0.95-0.2,1.4 l18.58,30.8c0,0,0,0,0,0c0.39,0.65,0.5,1.42,0.32,2.16c-0.19,0.74-0.65,1.36-1.31,1.75 C165.29,411.06,164.79,411.19,164.28,411.19z M144.13,377.55c0.35,0,0.67,0.18,0.86,0.48l18.55,30.74 c0.12,0.2,0.31,0.34,0.53,0.4c0.22,0.05,0.45,0.02,0.64-0.09c0.2-0.12,0.34-0.3,0.39-0.53c0.06-0.22,0.02-0.45-0.09-0.64 l-18.83-31.2c-0.16-0.27-0.19-0.61-0.07-0.9c0.15-0.36,0.23-0.74,0.23-1.13v-0.27c0-1.63-1.32-2.95-2.95-2.95 c-1.63,0-2.95,1.32-2.95,2.95v0.27c0,1.63,1.32,2.95,2.95,2.95c0.18,0,0.36-0.02,0.56-0.05 C144.01,377.55,144.07,377.55,144.13,377.55z"
  }))), /*#__PURE__*/React.createElement("g", null, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M145.96,368.76c0-0.03,0.01-0.06,0.01-0.1v-23.68c0-1.2-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16 v23.68c0,0.03,0.01,0.06,0.01,0.1c-2.26,0.87-3.87,3.05-3.87,5.62c0,3.33,2.7,6.03,6.03,6.03c3.33,0,6.03-2.7,6.03-6.03 C149.83,371.81,148.22,369.63,145.96,368.76z M143.81,377.47c-1.71,0-3.09-1.38-3.09-3.09c0-1.71,1.38-3.09,3.09-3.09 c1.71,0,3.09,1.38,3.09,3.09C146.9,376.09,145.51,377.47,143.81,377.47z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_114_",
    gradientUnits: "userSpaceOnUse",
    x1: 136.7803,
    y1: 361.6138,
    x2: 150.8335,
    y2: 361.6138
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st115",
    d: "M143.81,381.41c-3.88,0-7.03-3.15-7.03-7.03c0-2.65,1.53-5.08,3.86-6.27v-23.13 c0-1.74,1.42-3.16,3.16-3.16c1.74,0,3.16,1.42,3.16,3.16v23.13c2.34,1.18,3.86,3.62,3.86,6.27 C150.83,378.25,147.68,381.41,143.81,381.41z M143.81,343.82c-0.64,0-1.16,0.52-1.16,1.16v23.68c0.02,0.43-0.23,0.88-0.63,1.03 c-1.93,0.74-3.23,2.62-3.23,4.69c0,2.77,2.26,5.03,5.03,5.03c2.77,0,5.03-2.26,5.03-5.03c0-2.06-1.3-3.95-3.23-4.69 c-0.4-0.15-0.66-0.55-0.64-0.98c0-0.03,0.01-0.1,0.01-0.12l0-23.6C144.97,344.34,144.45,343.82,143.81,343.82z M143.81,378.47 c-2.26,0-4.09-1.84-4.09-4.09c0-2.25,1.84-4.09,4.09-4.09c2.26,0,4.09,1.84,4.09,4.09C147.9,376.64,146.06,378.47,143.81,378.47 z M143.81,372.29c-1.15,0-2.09,0.94-2.09,2.09c0,1.15,0.94,2.09,2.09,2.09c1.15,0,2.09-0.94,2.09-2.09 C145.9,373.23,144.96,372.29,143.81,372.29z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 141.18,
    y: 318.36,
    className: "st43",
    width: 5.17,
    height: 11.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_115_",
    gradientUnits: "userSpaceOnUse",
    x1: 140.1758,
    y1: 324.3394,
    x2: 147.3443,
    y2: 324.3394
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC20B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F24B89"
    }
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st116",
    d: "M146.34,331.32h-5.17c-0.55,0-1-0.45-1-1v-11.95c0-0.55,0.45-1,1-1h5.17c0.55,0,1,0.45,1,1v11.95 C147.34,330.87,146.9,331.32,146.34,331.32z M142.18,329.32h3.17v-9.95h-3.17V329.32z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 169.11,
    y: 332.82,
    transform: "matrix(0.6284 -0.7779 0.7779 0.6284 -195.8525 260.8421)",
    className: "st43",
    width: 11.95,
    height: 5.17
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_116_",
    gradientUnits: "userSpaceOnUse",
    x1: 168.3163,
    y1: 335.4094,
    x2: 181.8483,
    y2: 335.4094
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC20B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F24B89"
    }
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M173.34,342.68c-0.22,0-0.44-0.07-0.63-0.22l-4.02-3.25c-0.21-0.17-0.34-0.41-0.37-0.67 c-0.03-0.26,0.05-0.53,0.22-0.73l7.51-9.29c0.35-0.43,0.98-0.49,1.41-0.15l4.02,3.25c0.21,0.17,0.34,0.41,0.37,0.67 c0.03,0.26-0.05,0.53-0.22,0.73l-7.51,9.29C173.92,342.55,173.63,342.68,173.34,342.68z M170.72,338.28l2.46,1.99l6.25-7.74 l-2.46-1.99L170.72,338.28z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 185.68,
    y: 357.8,
    transform: "matrix(0.961 -0.2766 0.2766 0.961 -92.2099 67.0766)",
    className: "st43",
    width: 11.95,
    height: 5.17
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_117_",
    gradientUnits: "userSpaceOnUse",
    x1: 184.1936,
    y1: 360.3806,
    x2: 199.1082,
    y2: 360.3806
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC20B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F24B89"
    }
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M186.62,365.52c-0.17,0-0.33-0.04-0.48-0.12c-0.23-0.13-0.4-0.34-0.48-0.6l-1.43-4.97 c-0.15-0.53,0.15-1.08,0.68-1.24l11.48-3.31c0.26-0.07,0.53-0.04,0.76,0.09c0.23,0.13,0.4,0.34,0.48,0.6l1.43,4.97 c0.15,0.53-0.15,1.08-0.68,1.24l-11.48,3.31C186.81,365.5,186.72,365.52,186.62,365.52z M186.43,360.23l0.88,3.04l9.56-2.75 l-0.88-3.04L186.43,360.23z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 188.32,
    y: 384.36,
    transform: "matrix(0.3246 -0.9459 0.9459 0.3246 -240.2668 444.1983)",
    className: "st43",
    width: 5.17,
    height: 11.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_118_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.4109,
    y1: 390.3369,
    x2: 198.3899,
    y2: 390.3369
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC20B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F24B89"
    }
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st119",
    d: "M195.71,395.72c-0.11,0-0.22-0.02-0.32-0.05l-11.3-3.88c-0.52-0.18-0.8-0.75-0.62-1.27l1.68-4.89 c0.09-0.25,0.27-0.46,0.51-0.57c0.24-0.12,0.51-0.13,0.76-0.05l11.3,3.88c0.52,0.18,0.8,0.75,0.62,1.27l-1.68,4.89 c-0.09,0.25-0.27,0.46-0.51,0.57C196.02,395.69,195.86,395.72,195.71,395.72z M185.68,390.22l9.41,3.23l1.03-3l-9.41-3.23 L185.68,390.22z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 170.52,
    y: 408.47,
    transform: "matrix(0.8084 -0.5886 0.5886 0.8084 -210.7718 181.2704)",
    className: "st43",
    width: 5.17,
    height: 11.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_119_",
    gradientUnits: "userSpaceOnUse",
    x1: 166.496,
    y1: 414.4478,
    x2: 179.7095,
    y2: 414.4478
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC20B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F24B89"
    }
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st120",
    d: "M174.53,421.8c-0.31,0-0.61-0.14-0.81-0.41l-7.03-9.66c-0.16-0.21-0.22-0.48-0.18-0.74 c0.04-0.26,0.19-0.5,0.4-0.65l4.18-3.04c0.45-0.32,1.07-0.23,1.4,0.22l7.03,9.66c0.16,0.21,0.22,0.48,0.18,0.74 c-0.04,0.26-0.19,0.5-0.4,0.65l-4.18,3.04C174.94,421.74,174.74,421.8,174.53,421.8z M168.89,411.36l5.86,8.04l2.56-1.87 l-5.86-8.04L168.89,411.36z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 142.11,
    y: 418.01,
    transform: "matrix(0.9998 -0.0186 0.0186 0.9998 -7.8579 2.7635)",
    className: "st43",
    width: 5.17,
    height: 11.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_120_",
    gradientUnits: "userSpaceOnUse",
    x1: 140.9998,
    y1: 423.9887,
    x2: 148.3908,
    y2: 423.9887
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC20B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F24B89"
    }
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "M142.22,431.01c-0.26,0-0.51-0.1-0.69-0.28c-0.19-0.19-0.3-0.44-0.31-0.7L141,418.08 c-0.01-0.55,0.43-1.01,0.98-1.02l5.17-0.1c0.28,0,0.52,0.1,0.71,0.28c0.19,0.19,0.3,0.44,0.31,0.7l0.22,11.95 c0.01,0.55-0.43,1.01-0.98,1.02l-5.17,0.1C142.23,431.01,142.23,431.01,142.22,431.01z M143.02,419.04l0.18,9.95l3.17-0.06 l-0.19-9.95L143.02,419.04z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 109.98,
    y: 412.93,
    transform: "matrix(0.558 -0.8298 0.8298 0.558 -293.5547 279.8717)",
    className: "st43",
    width: 11.95,
    height: 5.17
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_121_",
    gradientUnits: "userSpaceOnUse",
    x1: 109.4727,
    y1: 415.5098,
    x2: 122.4306,
    y2: 415.5098
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC20B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F24B89"
    }
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st122",
    d: "M114.76,422.91c-0.19,0-0.39-0.05-0.56-0.17l-4.29-2.88c-0.22-0.15-0.37-0.38-0.42-0.64 c-0.05-0.26,0-0.53,0.15-0.75l6.67-9.92c0.31-0.46,0.93-0.58,1.39-0.27l4.29,2.88c0.22,0.15,0.37,0.38,0.42,0.64 c0.05,0.26,0,0.53-0.15,0.75l-6.67,9.91C115.4,422.75,115.08,422.91,114.76,422.91z M111.86,418.75l2.63,1.77l5.55-8.26 l-2.63-1.77L111.86,418.75z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 91.3,
    y: 389.49,
    transform: "matrix(0.9331 -0.3595 0.3595 0.9331 -134.4563 61.1861)",
    className: "st43",
    width: 11.95,
    height: 5.17
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_122_",
    gradientUnits: "userSpaceOnUse",
    x1: 89.7662,
    y1: 392.0781,
    x2: 104.7748,
    y2: 392.0781
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC20B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F24B89"
    }
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "M92.62,397.64c-0.4,0-0.78-0.24-0.93-0.64l-1.86-4.82c-0.1-0.25-0.09-0.52,0.02-0.76 c0.11-0.24,0.31-0.43,0.55-0.53l11.15-4.3c0.25-0.1,0.52-0.09,0.77,0.02c0.24,0.11,0.43,0.31,0.53,0.55l1.86,4.82 c0.1,0.25,0.09,0.52-0.02,0.76c-0.11,0.24-0.31,0.43-0.55,0.53l-11.15,4.29C92.87,397.62,92.74,397.64,92.62,397.64z  M92.06,392.39l1.14,2.96l9.28-3.58l-1.14-2.96L92.06,392.39z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 92.82,
    y: 356.19,
    transform: "matrix(0.2408 -0.9706 0.9706 0.2408 -279.0781 367.5696)",
    className: "st43",
    width: 5.17,
    height: 11.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_123_",
    gradientUnits: "userSpaceOnUse",
    x1: 87.9862,
    y1: 362.1689,
    x2: 102.8283,
    y2: 362.1689
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC20B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F24B89"
    }
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M100.58,367.12c-0.08,0-0.16-0.01-0.24-0.03l-11.6-2.88c-0.26-0.06-0.48-0.23-0.62-0.46 c-0.14-0.23-0.18-0.5-0.11-0.76l1.25-5.02c0.13-0.54,0.68-0.86,1.21-0.73l11.6,2.88c0.26,0.06,0.48,0.23,0.62,0.45 c0.14,0.23,0.18,0.5,0.11,0.76l-1.24,5.02C101.44,366.81,101.03,367.12,100.58,367.12z M90.2,362.51l9.66,2.4l0.76-3.08 l-9.66-2.4L90.2,362.51z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 108.45,
    y: 330.63,
    transform: "matrix(0.7539 -0.657 0.657 0.7539 -193.8187 155.791)",
    className: "st43",
    width: 5.17,
    height: 11.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_124_",
    gradientUnits: "userSpaceOnUse",
    x1: 104.1632,
    y1: 336.6,
    x2: 117.9095,
    y2: 336.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC20B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F24B89"
    }
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "M113.01,343.8c-0.28,0-0.56-0.12-0.75-0.34l-7.85-9.01c-0.36-0.42-0.32-1.05,0.1-1.41l3.9-3.4 c0.2-0.17,0.47-0.25,0.73-0.24c0.26,0.02,0.51,0.14,0.69,0.34l7.85,9.01c0.17,0.2,0.26,0.46,0.24,0.72 c-0.02,0.27-0.14,0.51-0.34,0.69l-3.9,3.39C113.48,343.72,113.25,343.8,113.01,343.8z M106.57,333.89l6.54,7.5l2.39-2.08 l-6.54-7.5L106.57,333.89z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_125_",
    gradientUnits: "userSpaceOnUse",
    x1: 1577.5643,
    y1: 239.6469,
    x2: 1590.9888,
    y2: 239.6469,
    gradientTransform: "matrix(0.9192 0.3939 -0.3939 0.9192 -904.9474 -447.2429)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    style: {
      stopColor: "#FA9A35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    style: {
      stopColor: "#F67160"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6939,
    style: {
      stopColor: "#F35480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#F14193"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M463.21,396.51c-3.5-1.72-4.46-5.72-4.89-5.94c-0.11-0.05-0.2-0.21-0.53,0.1 c-0.95,0.89,0.35,4.89,0.65,5.58c-1.67,0.06-2.18,0.12-4.05-0.01c-2.83-0.19-6.33,0.86-5.07,3.58c0.9,1.96,1.31,2.24,6.62,2.24 c0.81,0,4.46-0.37,6.28-0.31L463.21,396.51z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M461.48,402.39c2.23,0.94,17.71,0.09,23.98,0c1.82-0.03,5.61-2.21,6.15-3.95c2-6.4,6.48-16.2,3.87-26.49 c-0.45-1.77-4.85-2.73-7.26-0.77c-4.8,3.89-4.79,21.98-4.79,21.98s-13.96,0.38-20.88,1.69 C459.97,395.34,458.86,401.29,461.48,402.39z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_126_",
    gradientUnits: "userSpaceOnUse",
    x1: 1866.7933,
    y1: 386.4649,
    x2: 1905.0857,
    y2: 386.4649,
    gradientTransform: "matrix(1 0 0 1 -1407.8112 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC706"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F14194"
    }
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "M467.68,403.83c-3.37,0-5.68-0.14-6.59-0.52l0,0c-1.51-0.64-2.31-2.43-2.07-4.67 c0.22-2.03,1.35-4.39,3.34-4.77c5.93-1.13,16.77-1.56,20.07-1.68c0.06-4.12,0.62-18.12,5.15-21.79 c1.84-1.5,4.51-1.55,6.33-0.95c1.36,0.45,2.28,1.27,2.53,2.24c2.29,9.02-0.67,17.63-2.83,23.92c-0.38,1.11-0.74,2.15-1.04,3.12 c-0.72,2.31-5.01,4.62-7.09,4.65c-1.56,0.02-3.7,0.09-6.05,0.17C474.8,403.72,470.79,403.83,467.68,403.83z M491.59,371.09 c-0.97,0-1.98,0.24-2.75,0.86c-3.63,2.95-4.42,16.31-4.42,21.21l0,0.97l-0.97,0.03c-0.14,0-13.96,0.39-20.72,1.67 c-0.79,0.15-1.56,1.5-1.72,3.02c-0.11,1,0.05,2.28,0.86,2.62l0,0c1.47,0.62,11.5,0.29,17.49,0.09 c2.37-0.08,4.52-0.15,6.09-0.17c1.58-0.02,4.84-2.06,5.21-3.25c0.31-0.98,0.67-2.04,1.06-3.17c2.08-6.05,4.93-14.33,2.79-22.77 c-0.06-0.23-0.46-0.59-1.22-0.84C492.8,371.19,492.21,371.09,491.59,371.09z"
  })))), /*#__PURE__*/React.createElement("g", null, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M458.79,465.55c-2.27-0.59-4.79-0.83-4.93-0.87c0,0-11.38,2.35-16.24,0.98c-2.07-0.58-4.04,3.41,0.75,4.75 c8.81,2.47,15.71,2.81,15.71,2.81l-0.06,1.53c-0.01-0.01,6.11,1.72,6.11,1.72c0.25-0.9,2.29-3.04,2.89-5.19 C463.52,469.45,462.08,466.4,458.79,465.55z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_127_",
    gradientUnits: "userSpaceOnUse",
    x1: 1842.2091,
    y1: 470.6714,
    x2: 1871.9218,
    y2: 470.6714,
    gradientTransform: "matrix(1 0 0 1 -1407.8112 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC706"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F14194"
    }
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st128",
    d: "M460.8,477.69l-6.11-1.71c-1.13-0.32-1.84-0.52-1.68-1.36l0.02-0.47c-2.23-0.19-7.96-0.82-14.94-2.78 c-2.65-0.74-3.39-2.21-3.6-3.02c-0.27-1.06,0.05-2.2,0.83-2.96c0.71-0.69,1.66-0.95,2.56-0.7c4.57,1.28,15.66-0.98,15.77-1 l0.24-0.05l0.23,0.07c-0.03-0.01,0.08,0,0.23,0.02c0.84,0.11,2.82,0.36,4.68,0.84l0,0c1.86,0.48,3.39,1.62,4.3,3.2 c0.72,1.26,0.95,2.63,0.63,3.77c-0.41,1.46-1.35,2.83-2.1,3.92c-0.31,0.45-0.73,1.06-0.79,1.27L460.8,477.69z M455.04,474 c1.16,0.33,3.37,0.95,4.55,1.28c0.17-0.28,0.39-0.59,0.63-0.94c0.67-0.97,1.5-2.19,1.82-3.33c0.17-0.61,0-1.46-0.44-2.23 c-0.37-0.64-1.26-1.8-3.07-2.26l0,0c-1.74-0.45-3.63-0.69-4.43-0.79c-0.08-0.01-0.15-0.02-0.22-0.03 c-1.51,0.3-11.78,2.26-16.54,0.93c-0.28-0.07-0.51,0.09-0.62,0.2c-0.21,0.21-0.4,0.59-0.29,1.04c0.17,0.66,0.97,1.24,2.2,1.58 c8.59,2.41,15.42,2.77,15.49,2.77l0.99,0.05L455.04,474z"
  }))), /*#__PURE__*/React.createElement("g", null, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M510.65,414.6c-0.46-2.02-2.01-6.52-3.29-7.96l-20.59,2.25c0,0-0.98,3.18-1.16,6.97 c-8.03,2.88-15.16,8.29-20.45,11.92c-0.03,0.02-1.88,1.33-1.91,1.35c-1.52,0.8-2.55,2.23-2.83,3.8 c-1.42,7.7-3.93,24.23-6.42,30.64c-0.94,2.41,2.67,6.61,8.35,6.61c2.44,0,9.32-26.88,8.77-32.08c0,0,14.04-4.04,22.6-9.64 c3.37,0.85,6.88,0.72,7.88,0.49c3.23-0.73,5.85-2.71,7.49-5.3C510.73,421.05,511.38,417.83,510.65,414.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_128_",
    gradientUnits: "userSpaceOnUse",
    x1: 1860.6732,
    y1: 438.3853,
    x2: 1919.7645,
    y2: 438.3853,
    gradientTransform: "matrix(1 0 0 1 -1407.8112 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC706"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F14194"
    }
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st129",
    d: "M462.36,471.18L462.36,471.18c-4.27-0.01-7.21-2.09-8.55-4.05c-0.92-1.34-1.18-2.77-0.73-3.93 c1.95-5.02,3.93-16.48,5.38-24.84c0.37-2.13,0.7-4.06,0.99-5.63c0.35-1.89,1.6-3.57,3.35-4.5c0.03-0.03,1.29-0.92,1.68-1.2 l0.12-0.08c0.73-0.5,1.48-1.02,2.26-1.57c4.91-3.43,10.99-7.68,17.8-10.24c0.25-3.56,1.12-6.42,1.16-6.55l0.19-0.63l21.76-2.38 l0.34,0.39c1.54,1.75,3.12,6.65,3.51,8.41l0,0c0.77,3.39,0.17,6.87-1.69,9.79c-1.85,2.94-4.74,4.98-8.12,5.75 c-1.12,0.25-4.52,0.38-7.91-0.39c-7.55,4.82-18.75,8.4-21.75,9.31c-0.09,6.35-5.62,28.47-8.52,31.69 C463.24,470.96,462.81,471.18,462.36,471.18z M487.56,409.81c-0.28,1.09-0.82,3.45-0.94,6.1l-0.03,0.67l-0.63,0.22 c-6.81,2.44-12.99,6.76-17.95,10.23c-0.79,0.55-1.54,1.08-2.27,1.57l-0.1,0.07c-1.82,1.29-1.82,1.29-1.9,1.33 c-1.22,0.64-2.08,1.8-2.32,3.1c-0.29,1.56-0.62,3.48-0.99,5.61c-1.46,8.44-3.46,20.01-5.48,25.22c-0.2,0.53-0.01,1.3,0.52,2.08 c0.98,1.44,3.32,3.11,6.7,3.17c2.33-2.21,8.49-26.03,7.97-30.97l-0.09-0.83l0.81-0.23c0.14-0.04,13.99-4.07,22.32-9.52 l0.37-0.24l0.42,0.11c3.22,0.81,6.56,0.68,7.41,0.49c2.86-0.65,5.3-2.38,6.87-4.86c1.57-2.48,2.08-5.42,1.43-8.29l0,0 c-0.45-2-1.74-5.59-2.76-7.13L487.56,409.81z"
  }))), /*#__PURE__*/React.createElement("g", null, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M530,474.75c-0.23,0-0.44,0.04-0.66,0.07c-0.15-0.04-6.15,1.52-6.29,1.52c0,0-9.01,4.31-14.06,4.31 c-2.15,0-2.97,4.37,2,4.37c9.15,0,15.88-1.54,15.88-1.54l0.35,1.49c-0.02,0,6.35,0,6.35,0c0-0.94,1.38-3.55,1.38-5.78 C534.95,477.29,532.82,474.75,530,474.75z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_129_",
    gradientUnits: "userSpaceOnUse",
    x1: 1914.1086,
    y1: 479.8882,
    x2: 1943.7629,
    y2: 479.8882,
    gradientTransform: "matrix(1 0 0 1 -1407.8112 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC706"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F14194"
    }
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st130",
    d: "M510.99,486.02c-1.47,0-2.64-0.34-3.48-1.01c-0.78-0.62-1.21-1.5-1.21-2.45c0-1.6,1.21-2.91,2.69-2.91 c4.76,0,13.54-4.17,13.63-4.21l0.21-0.1h0.13c0.28-0.06,1.14-0.28,2.13-0.53c2.79-0.7,3.72-0.93,4.13-0.98v0l0.13-0.02 c0.22-0.03,0.43-0.06,0.66-0.06l0,0c0,0,0.01,0,0.01,0c1.57,0,3.07,0.64,4.25,1.82c1.06,1.06,1.69,2.41,1.69,3.63 c0,1.52-0.53,3.09-0.96,4.35c-0.18,0.52-0.42,1.22-0.42,1.43l-0.01,0.99l-0.99,0.01l-5.35,0c-1.18,0-1.92,0-1.99-0.86 l-0.11-0.45C523.93,485.08,518.24,486.02,510.99,486.02z M523.37,477.3c-1.13,0.53-9.42,4.36-14.38,4.36 c-0.41,0-0.69,0.47-0.69,0.91c0,0.24,0.08,0.59,0.46,0.89c0.33,0.26,0.98,0.57,2.23,0.57c8.94,0,15.6-1.5,15.66-1.51l0.97-0.22 l0.4,1.68l4.73,0c0.09-0.32,0.21-0.67,0.35-1.08c0.38-1.12,0.86-2.51,0.86-3.7c0-0.68-0.43-1.54-1.1-2.21 c-0.46-0.46-1.44-1.23-2.84-1.23c0,0-0.01,0-0.01,0h0c-0.13,0-0.26,0.02-0.38,0.04l-0.25,0.04c-0.48,0.09-2.54,0.61-3.8,0.93 C524.21,477.09,523.64,477.23,523.37,477.3z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M501.9,416.95c2.18-2.5,12.88-3.29,13.25,0c1.75,15.6-5.09,28.16-5.09,31.54 c11.86,7.62,17.48,20.02,22.3,26.84c0.66,0.93-7.15,3.39-11.68,1.88c0,0-13.46-16.06-21.2-23.33c-1.16-1.08-1.59-2.84-1.32-4.52 C498.16,449.35,496.55,423.1,501.9,416.95z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_130_",
    gradientUnits: "userSpaceOnUse",
    x1: 1904.7484,
    y1: 446.2332,
    x2: 1941.2157,
    y2: 446.2332,
    gradientTransform: "matrix(1 0 0 1 -1407.8112 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC706"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F14194"
    }
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "M524.18,478.69c-1.36,0-2.68-0.16-3.81-0.54l-0.27-0.09l-0.18-0.22c-0.13-0.16-13.51-16.1-21.12-23.24 c-1.34-1.25-1.95-3.23-1.64-5.3c-0.07-1.31-0.74-14.02,0.68-23.43l1.98,0.3c-1.46,9.68-0.66,22.99-0.66,23.12l0.01,0.11 l-0.02,0.11c-0.23,1.43,0.16,2.83,1.02,3.63c7.2,6.75,19.43,21.21,21.09,23.19c3.35,0.97,8.3-0.29,9.86-1.05 c-0.96-1.41-1.97-3.03-3.02-4.73c-4.26-6.88-9.56-15.43-18.57-21.23l-0.46-0.29v-0.55c0-1.12,0.55-2.8,1.37-5.32 c1.85-5.68,4.96-15.18,3.73-26.1c-0.05-0.48-0.91-0.8-1.27-0.91c-3.2-1-9,0.05-10.23,1.46l-1.51-1.31 c2-2.3,8.87-3.14,12.34-2.05c2.03,0.63,2.57,1.76,2.67,2.6c1.27,11.35-1.91,21.11-3.81,26.94c-0.56,1.73-1.06,3.26-1.22,4.2 c9.08,6.03,14.4,14.6,18.68,21.52c1.19,1.93,2.32,3.75,3.38,5.25c0.32,0.45,0.3,1.02-0.05,1.48 C532.29,477.36,528.1,478.69,524.18,478.69z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M514.51,380.14c0-5.49-5.29-10.75-8.69-11.17c-5.76,0.81-13.56,0.21-15.39,1.03 c-3.72,1.66-5.1,7.8-5.38,11.89c-0.62,9.27,0.04,23.67-1,34.07c-0.62,6.18,32.45,9.12,32.45,5.51 C516.5,407.89,514.51,386.29,514.51,380.14z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_131_",
    gradientUnits: "userSpaceOnUse",
    x1: 1890.8502,
    y1: 395.9947,
    x2: 1925.3077,
    y2: 395.9947,
    gradientTransform: "matrix(1 0 0 1 -1407.8112 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC706"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F14194"
    }
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st132",
    d: "M509.45,424.03c-8.01,0-19.99-1.88-24.32-4.78c-1.5-1.01-2.2-2.15-2.08-3.39 c0.59-5.85,0.63-12.94,0.67-19.8c0.03-5.24,0.06-10.19,0.33-14.23c0.17-2.44,1.08-10.56,5.97-12.74 c1.07-0.48,3.19-0.54,6.84-0.61c2.85-0.05,6.08-0.11,8.82-0.5l0.13-0.02l0.13,0.02c3.78,0.46,9.57,6.09,9.57,12.16 c0,2.44,0.33,7.49,0.7,13.33c0.57,8.85,1.29,19.85,1.29,28c0,0.38-0.15,1.1-1.12,1.62 C515.17,423.73,512.62,424.03,509.45,424.03z M505.81,369.98c-2.83,0.38-6.06,0.45-8.92,0.5c-2.61,0.05-5.31,0.1-6.06,0.43 c-3.07,1.37-4.5,6.81-4.78,11.04c-0.27,3.98-0.3,8.9-0.33,14.11c-0.04,6.9-0.08,14.04-0.68,19.99 c-0.07,0.66,0.92,1.53,2.64,2.32c7.97,3.66,25.86,4.41,27.82,2.93c-0.01-8.07-0.71-18.95-1.28-27.7 c-0.38-5.88-0.71-10.95-0.71-13.46C513.51,375.29,508.77,370.45,505.81,369.98z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M497.93,396.58c0,0.74-0.65,1.35-1.45,1.35h-29.81c-0.8,0-1.45-0.61-1.45-1.35 c0-0.74,0.65-1.34,1.45-1.34h29.81C497.28,395.24,497.93,395.84,497.93,396.58z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_132_",
    gradientUnits: "userSpaceOnUse",
    x1: 2065.6399,
    y1: 396.5815,
    x2: 2099.3499,
    y2: 396.5815,
    gradientTransform: "matrix(1 0 0 1 -1600.9167 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2903,
    style: {
      stopColor: "#964AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03FFFF"
    }
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st133",
    d: "M464.72,396.58c0-1.02,0.87-1.84,1.95-1.84h29.81c1.08,0,1.95,0.83,1.95,1.84s-0.88,1.85-1.95,1.85 h-29.81C465.6,398.43,464.72,397.6,464.72,396.58z M466.67,395.74c-0.52,0-0.95,0.38-0.95,0.84c0,0.47,0.42,0.85,0.95,0.85 h29.81c0.52,0,0.95-0.38,0.95-0.85c0-0.46-0.43-0.84-0.95-0.84H466.67z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M434.66,368.68v24.58c0,1.09,0.89,1.98,1.98,1.98h37.19c1.09,0,1.98-0.89,1.98-1.98v-24.58 c0-1.09-0.89-1.98-1.98-1.98h-37.19C435.55,366.69,434.66,367.58,434.66,368.68z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_133_",
    gradientUnits: "userSpaceOnUse",
    x1: 2035.0778,
    y1: 380.9644,
    x2: 2077.2278,
    y2: 380.9644,
    gradientTransform: "matrix(1 0 0 1 -1600.9167 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#964AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03FFFF"
    }
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M434.16,393.25v-24.58c0-1.37,1.11-2.48,2.48-2.48h37.18c1.37,0,2.48,1.11,2.48,2.48v24.58 c0,1.37-1.11,2.48-2.48,2.48h-37.18C435.27,395.73,434.16,394.62,434.16,393.25z M436.64,367.19c-0.82,0-1.48,0.67-1.48,1.48 v24.58c0,0.82,0.67,1.48,1.48,1.48h37.18c0.82,0,1.48-0.66,1.48-1.48v-24.58c0-0.82-0.67-1.48-1.48-1.48H436.64z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M473.59,396.58c0-0.74-0.6-1.35-1.35-1.35h-36.12c-1.02,0-1.46,0.6-1.46,1.34 c0,0.74,0.44,1.35,1.46,1.35h36.12C472.98,397.93,473.59,397.32,473.59,396.58L473.59,396.58z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_134_",
    gradientUnits: "userSpaceOnUse",
    x1: 2035.0778,
    y1: 396.5815,
    x2: 2075.0022,
    y2: 396.5815,
    gradientTransform: "matrix(1 0 0 1 -1600.9167 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#964AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238,
    style: {
      stopColor: "#944DE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#8D55E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5178,
    style: {
      stopColor: "#8164E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6324,
    style: {
      stopColor: "#7079EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#5A94EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8371,
    style: {
      stopColor: "#3FB5F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9293,
    style: {
      stopColor: "#20DCF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03FFFF"
    }
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "st135",
    d: "M434.16,396.58c0-1.12,0.77-1.84,1.96-1.84h36.12c1.02,0,1.85,0.83,1.85,1.85 c0,1.02-0.83,1.84-1.85,1.84h-36.12C434.93,398.43,434.16,397.7,434.16,396.58z M436.12,395.74c-0.64,0-0.96,0.28-0.96,0.84 c0,0.57,0.31,0.85,0.96,0.85h36.12c0.47,0,0.85-0.38,0.85-0.84c0-0.47-0.38-0.85-0.85-0.85H436.12z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M487.63,349.15c-13.83-3.01-3.87-11.8-3.87-11.8s0.28,3.28,2.95,2.21c5.12-2.06,16.28-3.35,19.34,3.35 c2.39,5.21-2.06,16.62-2.9,19.59c-1.38-0.86-0.22-14.29-5.89-13.72C494.17,349.07,490.65,349.81,487.63,349.15z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_135_",
    gradientUnits: "userSpaceOnUse",
    x1: 1887.0983,
    y1: 349.6646,
    x2: 1915.5593,
    y2: 349.6646,
    gradientTransform: "matrix(1 0 0 1 -1407.8112 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC706"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F14194"
    }
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "M503.75,364.05l-1.13-0.71c-0.82-0.51-0.98-1.7-1.32-4.57c-0.54-4.7-1.28-9.25-3.94-9.01 c-0.67,0.07-1.36,0.15-2.07,0.24c-2.63,0.33-5.36,0.67-7.88,0.12l0,0c-4.63-1.01-7.31-2.81-7.97-5.35 c-1.04-3.98,3.46-8.01,3.65-8.18l1.49-1.32l0.17,1.98c0.03,0.35,0.24,1.17,0.65,1.42c0.2,0.12,0.52,0.1,0.94-0.06 c4.99-2,17.11-3.81,20.62,3.86c2.19,4.78-0.71,13.67-2.27,18.45c-0.25,0.76-0.45,1.39-0.58,1.83L503.75,364.05z M497.64,347.75 c4.41,0,5.15,6.46,5.65,10.79c0.01,0.05,0.01,0.11,0.02,0.16c1.44-4.53,3.48-11.78,1.83-15.39 c-2.72-5.94-13.27-4.75-18.06-2.84c-1.3,0.52-2.2,0.24-2.74-0.09c-0.47-0.29-0.8-0.71-1.04-1.13 c-1.12,1.33-2.37,3.34-1.93,5.02c0.45,1.73,2.68,3.07,6.46,3.89c2.19,0.48,4.74,0.16,7.21-0.15c0.72-0.09,1.43-0.18,2.12-0.25 C497.33,347.76,497.49,347.75,497.64,347.75z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_136_",
    gradientUnits: "userSpaceOnUse",
    x1: 1891.0094,
    y1: 359.0728,
    x2: 1911.5109,
    y2: 359.0728,
    gradientTransform: "matrix(1 0 0 1 -1407.8112 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    style: {
      stopColor: "#FA9A35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    style: {
      stopColor: "#F67160"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6939,
    style: {
      stopColor: "#F35480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#F14193"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M497.27,348.77c-3.1,0.31-6.62,1.04-9.64,0.38c-1.71-0.37-3.06-0.84-4.11-1.36c0,0.15,0,0.3,0.01,0.45 c0.22,2.56-0.18,4.46-0.33,8.24c-0.13,3.17,3.17,8.68,6.51,9.59c0.35,0.1,1.04,0.29,1.4,0.34c1.06,0.17,2.26,0.03,3.46-0.34 l0.21,4.28h8.92l-0.55-7.87C501.77,361.63,502.94,348.21,497.27,348.77z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st138",
    d: "M489.72,363.53c-2.83-0.12-1.01-4.79,0.07-4.74C490.87,358.85,492.55,363.65,489.72,363.53z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_137_",
    gradientUnits: "userSpaceOnUse",
    x1: 1898.6619,
    y1: 378.2867,
    x2: 1910.8361,
    y2: 378.2867,
    gradientTransform: "matrix(1 0 0 1 -1407.8112 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    style: {
      stopColor: "#FA9A35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    style: {
      stopColor: "#F67160"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6939,
    style: {
      stopColor: "#F35480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#F14193"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "st139",
    d: "M493.83,370.27c1.64-0.39,4.55-0.49,9.19-1.05c-2.57,6.04-9.51,11.06-11.57,18.13 C490.38,386.17,490.49,372.59,493.83,370.27z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_138_",
    gradientUnits: "userSpaceOnUse",
    x1: 1898.6642,
    y1: 378.6737,
    x2: 1904.8693,
    y2: 378.6737,
    gradientTransform: "matrix(1 0 0 1 -1407.8112 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M494.12,371.38c0.3-0.34,1.26-1.01,1.29-1.37c0.74-0.09,0.62,0.19,1.65,0.09 c-2.81,2.6-1.19,6.88-2.29,10.8c-1.41,2-2.63,4.11-3.31,6.45c-0.6-0.65-0.83-5.11-0.35-9.35 C491.16,377.54,491.83,373.99,494.12,371.38z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_139_",
    gradientUnits: "userSpaceOnUse",
    x1: 1901.3427,
    y1: 371.1801,
    x2: 1904.839,
    y2: 371.1801,
    gradientTransform: "matrix(1 0 0 1 -1407.8112 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "st141",
    d: "M493.79,372.05c0.35,0.46,1.86,0.69,2.33,0.35c0.45-0.32,0.9-2.08,0.9-2.08l-3.49-0.52 C493.54,369.8,493.45,371.61,493.79,372.05z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_140_",
    gradientUnits: "userSpaceOnUse",
    x1: 1902.8997,
    y1: 369.9995,
    x2: 1913.6262,
    y2: 369.9995,
    gradientTransform: "matrix(1 0 0 1 -1407.8112 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st142",
    points: "498.8,373.64 505.82,368.97 503.44,366.36 495.09,370.07  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_141_",
    gradientUnits: "userSpaceOnUse",
    x1: 1900.6075,
    y1: 370.2115,
    x2: 1902.926,
    y2: 370.2115,
    gradientTransform: "matrix(1 0 0 1 -1407.8112 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st143",
    points: "492.8,371.69 493.2,370.14 494.54,368.73 495.11,369.93  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_142_",
    gradientUnits: "userSpaceOnUse",
    x1: 1196.1812,
    y1: 515.0243,
    x2: 1209.6063,
    y2: 515.0243,
    gradientTransform: "matrix(0.6915 0.7224 -0.7224 0.6915 13.5286 -825.5723)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    style: {
      stopColor: "#FA9A35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    style: {
      stopColor: "#F67160"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6939,
    style: {
      stopColor: "#F35480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#F14193"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "st144",
    d: "M479.29,401.47c-2.55-2.95-1.86-7.01-2.17-7.38c-0.08-0.09-0.1-0.27-0.53-0.12 c-1.22,0.45-1.59,4.63-1.59,5.38c-1.56-0.6-2.05-0.75-3.72-1.59c-2.53-1.28-6.16-1.68-6.07,1.31c0.06,2.15,0.33,2.57,5.21,4.65 c0.74,0.32,4.25,1.41,5.9,2.18L479.29,401.47z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M476.92,406.97c2.23,0.94,17.71,0.09,23.98,0c1.82-0.03,5.61-2.21,6.15-3.95c2-6.4,6.48-16.2,3.87-26.49 c-0.45-1.77-6.11-3.11-7.81-1.75c-4.83,3.86-4.25,22.96-4.25,22.96s-13.96,0.38-20.88,1.69 C475.41,399.92,474.3,405.87,476.92,406.97z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_143_",
    gradientUnits: "userSpaceOnUse",
    x1: 1882.2302,
    y1: 391.2056,
    x2: 1920.4709,
    y2: 391.2056,
    gradientTransform: "matrix(1 0 0 1 -1407.8112 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC706"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F14194"
    }
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M483.11,408.41c-3.37,0-5.68-0.14-6.59-0.52c-1.51-0.64-2.31-2.43-2.07-4.67 c0.22-2.04,1.35-4.4,3.34-4.77c5.92-1.12,16.7-1.56,20.04-1.68c-0.06-4.31,0.06-19.12,4.64-22.78l1.25,1.56 c-3.64,2.91-4.03,16.98-3.87,22.15l0.03,1l-1,0.03c-0.14,0-13.96,0.39-20.72,1.67c-0.79,0.15-1.56,1.5-1.72,3.02 c-0.11,1,0.05,2.28,0.86,2.62c1.47,0.62,11.5,0.29,17.49,0.09c2.37-0.08,4.52-0.15,6.09-0.17c1.57-0.02,4.84-2.06,5.21-3.25 c0.31-0.98,0.67-2.04,1.06-3.18c1.42-4.14,3.19-9.28,3.5-14.76l2,0.11c-0.33,5.75-2.15,11.05-3.61,15.3 c-0.38,1.11-0.74,2.16-1.04,3.12c-0.72,2.31-5.01,4.62-7.09,4.65c-1.56,0.02-3.69,0.09-6.05,0.17 C490.23,408.3,486.23,408.41,483.11,408.41z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_144_",
    gradientUnits: "userSpaceOnUse",
    x1: 416.7223,
    y1: 125.437,
    x2: 513.7223,
    y2: 125.437
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M446.96,131.78c-4.18,0-8.11-1.51-11.07-4.26c-1.92-1.78-4.47-2.76-7.2-2.76c-2.73,0-5.28,0.98-7.2,2.76 c-1.11,1.03-2.99,0.96-4.02-0.15c-1.07-1.15-1-2.95,0.15-4.02c2.96-2.75,6.89-4.26,11.07-4.26c4.18,0,8.11,1.51,11.07,4.26 c1.92,1.78,4.47,2.76,7.2,2.76c2.73,0,5.28-0.98,7.2-2.76c2.96-2.75,6.88-4.26,11.07-4.26c4.18,0,8.11,1.51,11.07,4.26 c1.91,1.78,4.47,2.76,7.2,2.76c2.73,0,5.28-0.98,7.2-2.76c2.95-2.75,6.88-4.26,11.06-4.26c4.18,0,8.11,1.51,11.07,4.26 c1.15,1.07,1.21,2.87,0.15,4.02c-1.03,1.11-2.91,1.17-4.02,0.15c-1.92-1.78-4.47-2.76-7.2-2.76c-2.73,0-5.28,0.98-7.19,2.76 c-2.96,2.75-6.89,4.26-11.07,4.26c-4.18,0-8.11-1.51-11.06-4.26c-1.92-1.78-4.47-2.76-7.2-2.76c-2.73,0-5.28,0.98-7.2,2.76 C455.07,130.27,451.14,131.78,446.96,131.78z M428.69,122.76c3.23,0,6.27,1.17,8.56,3.29c2.58,2.4,6.03,3.72,9.7,3.72 c3.67,0,7.12-1.32,9.71-3.72c2.29-2.12,5.33-3.29,8.56-3.29c3.23,0,6.27,1.17,8.56,3.29c2.58,2.4,6.03,3.72,9.7,3.72 c3.68,0,7.12-1.32,9.71-3.72c2.28-2.12,5.32-3.29,8.56-3.29c3.23,0,6.27,1.17,8.56,3.29c0.33,0.31,0.88,0.29,1.19-0.04 c0.32-0.34,0.3-0.87-0.04-1.19c-2.58-2.4-6.03-3.72-9.7-3.72c-3.67,0-7.12,1.32-9.7,3.72c-2.29,2.12-5.33,3.29-8.56,3.29 c-3.23,0-6.27-1.17-8.56-3.29c-2.58-2.4-6.03-3.72-9.71-3.72c-3.67,0-7.12,1.32-9.7,3.72c-2.29,2.12-5.33,3.29-8.56,3.29 c-3.23,0-6.27-1.17-8.56-3.29c-2.58-2.4-6.03-3.72-9.71-3.72c-3.67,0-7.12,1.32-9.71,3.72c-0.34,0.32-0.36,0.85-0.04,1.19 c0.3,0.33,0.86,0.35,1.19,0.04C422.42,123.93,425.46,122.76,428.69,122.76z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_282_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_287_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "st147",
    d: "M297.28,100.1c8.06,0,14.59,5.63,14.59,12.58c0,4.17-2.35,7.87-5.98,10.16l2.05,5.2l-5.04-3.74 c-1.73,0.63-3.63,0.97-5.63,0.97c-8.06,0-14.59-5.63-14.59-12.59C282.7,105.73,289.23,100.1,297.28,100.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_145_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.5444,
    y1: 115.0171,
    x2: 103.7202,
    y2: 115.0171,
    gradientTransform: "matrix(1 0 0 1 209.1524 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F41DB"
    }
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M310.17,130.94l-7.43-5.52c-1.74,0.57-3.57,0.85-5.45,0.85c-8.59,0-15.59-6.09-15.59-13.59 c0-7.49,6.99-13.58,15.59-13.58s15.59,6.09,15.59,13.58c0,4.09-2.14,7.98-5.75,10.54L310.17,130.94z M303.08,123.17 l2.65,1.97l-1.07-2.7l0.7-0.44c3.45-2.18,5.51-5.66,5.51-9.32c0-6.39-6.1-11.58-13.59-11.58s-13.59,5.2-13.59,11.58 c0,6.39,6.1,11.59,13.59,11.59c1.83,0,3.61-0.31,5.29-0.91L303.08,123.17z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_283_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_286_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_146_",
    gradientUnits: "userSpaceOnUse",
    x1: 92.5361,
    y1: 112.9293,
    x2: 96.4907,
    y2: 112.9293,
    gradientTransform: "matrix(1 0 0 1 209.1524 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M303.67,114.91c-1.09,0-1.98-0.89-1.98-1.98c0-1.09,0.89-1.98,1.98-1.98c1.09,0,1.98,0.89,1.98,1.98 C305.64,114.02,304.75,114.91,303.67,114.91z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_285_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_147_",
    gradientUnits: "userSpaceOnUse",
    x1: 86.1557,
    y1: 112.9293,
    x2: 90.1093,
    y2: 112.9293,
    gradientTransform: "matrix(1 0 0 1 209.1524 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "st150",
    d: "M297.28,114.91c-1.09,0-1.98-0.89-1.98-1.98c0-1.09,0.89-1.98,1.98-1.98c1.09,0,1.98,0.89,1.98,1.98 C299.26,114.02,298.37,114.91,297.28,114.91z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_284_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_148_",
    gradientUnits: "userSpaceOnUse",
    x1: 79.7749,
    y1: 112.9293,
    x2: 83.729,
    y2: 112.9293,
    gradientTransform: "matrix(1 0 0 1 209.1524 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "st151",
    d: "M290.9,114.91c-1.09,0-1.98-0.89-1.98-1.98c0-1.09,0.89-1.98,1.98-1.98c1.09,0,1.98,0.89,1.98,1.98 C292.88,114.02,291.99,114.91,290.9,114.91z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_149_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.6817,
    y1: 441.4458,
    x2: 237.8789,
    y2: 441.4458
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 149.68,
    y: 440.45,
    className: "st152",
    width: 88.2,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_150_",
    gradientUnits: "userSpaceOnUse",
    x1: 246.7466,
    y1: 463.2915,
    x2: 442.0947,
    y2: 463.2915
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 246.75,
    y: 462.29,
    className: "st153",
    width: 195.35,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_151_",
    gradientUnits: "userSpaceOnUse",
    x1: 432.4111,
    y1: 478.69,
    x2: 462.3384,
    y2: 478.69
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 432.41,
    y: 477.69,
    className: "st154",
    width: 29.93,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_152_",
    gradientUnits: "userSpaceOnUse",
    x1: 115.9517,
    y1: 441.4458,
    x2: 133.6851,
    y2: 441.4458
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 115.95,
    y: 440.45,
    className: "st155",
    width: 17.73,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_153_",
    gradientUnits: "userSpaceOnUse",
    x1: 528.0357,
    y1: 498.8052,
    x2: 579.8032,
    y2: 498.8052
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 528.04,
    y: 497.81,
    className: "st156",
    width: 51.77,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_154_",
    gradientUnits: "userSpaceOnUse",
    x1: 537.9429,
    y1: 489.9243,
    x2: 555.5083,
    y2: 489.9243
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 537.94,
    y: 488.92,
    className: "st157",
    width: 17.57,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_155_",
    gradientUnits: "userSpaceOnUse",
    x1: 508.2378,
    y1: 498.8052,
    x2: 518.647,
    y2: 498.8052
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 508.24,
    y: 497.81,
    className: "st158",
    width: 10.41,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_156_",
    gradientUnits: "userSpaceOnUse",
    x1: 614.1323,
    y1: 435.9458,
    x2: 644.2847,
    y2: 435.9458
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 614.13,
    y: 434.95,
    className: "st159",
    width: 30.15,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_157_",
    gradientUnits: "userSpaceOnUse",
    x1: 655.4732,
    y1: 435.9458,
    x2: 665.7046,
    y2: 435.9458
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 655.47,
    y: 434.95,
    className: "st160",
    width: 10.23,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_158_",
    gradientUnits: "userSpaceOnUse",
    x1: 602.6001,
    y1: 435.9458,
    x2: 608.6626,
    y2: 435.9458
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 602.6,
    y: 434.95,
    className: "st161",
    width: 6.06,
    height: 2
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_159_",
    gradientUnits: "userSpaceOnUse",
    x1: 301.063,
    y1: 471.0513,
    x2: 359.461,
    y2: 471.0513
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 301.06,
    y: 470.05,
    className: "st162",
    width: 58.4,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_160_",
    gradientUnits: "userSpaceOnUse",
    x1: 381.1304,
    y1: 471.0513,
    x2: 400.9463,
    y2: 471.0513
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 381.13,
    y: 470.05,
    className: "st163",
    width: 19.82,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_161_",
    gradientUnits: "userSpaceOnUse",
    x1: 278.7276,
    y1: 471.0513,
    x2: 290.4693,
    y2: 471.0513
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 278.73,
    y: 470.05,
    className: "st164",
    width: 11.74,
    height: 2
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_162_",
    gradientUnits: "userSpaceOnUse",
    x1: 597.0767,
    y1: 448.9458,
    x2: 615.3189,
    y2: 448.9458
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 597.08,
    y: 447.95,
    className: "st165",
    width: 18.24,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_163_",
    gradientUnits: "userSpaceOnUse",
    x1: 623.9536,
    y1: 448.9458,
    x2: 631.8491,
    y2: 448.9458
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 623.95,
    y: 447.95,
    className: "st166",
    width: 7.9,
    height: 2
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_164_",
    gradientUnits: "userSpaceOnUse",
    x1: 452.2036,
    y1: 490.9243,
    x2: 504.0562,
    y2: 490.9243
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 452.2,
    y: 489.92,
    className: "st167",
    width: 51.85,
    height: 2
  }))))), /*#__PURE__*/React.createElement("g", null, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_314_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M425.35,399.64l6.32,1.3l2.76-13.33l-6.32-1.3c0.11-5.32-0.92-10.48-2.91-15.2l5.39-3.55l-7.48-11.38 l-5.39,3.55c-2.79-2.91-6.07-5.38-9.75-7.29c-0.95-0.49-1.93-0.95-2.94-1.36c-0.04-0.02-0.08-0.03-0.12-0.05l1.32-6.32 l-13.33-2.76l-1.31,6.32c-1.39-0.03-2.78,0.02-4.15,0.14c-3.85,0.34-7.57,1.29-11.06,2.76l-3.55-5.39l-11.37,7.47l3.54,5.39 c-3.7,3.55-6.69,7.88-8.7,12.81l-6.32-1.3l-2.76,13.33l6.32,1.3c-0.11,5.32,0.91,10.48,2.9,15.21l-5.39,3.54l7.47,11.38 l5.4-3.54c3.54,3.7,7.88,6.69,12.81,8.7l-1.31,6.32l13.32,2.75l1.31-6.32c1.41,0.03,2.79-0.02,4.16-0.14 c3.85-0.35,7.57-1.3,11.05-2.76l3.55,5.39l11.37-7.48l-3.54-5.39C420.35,408.9,423.34,404.57,425.35,399.64z M393.33,412.97 c-2.64,0.24-5.36,0.1-8.08-0.46c-14.89-3.08-24.46-17.64-21.39-32.53c2.52-12.17,12.69-20.77,24.46-21.85 c2.64-0.24,5.35-0.1,8.08,0.46c1.57,0.33,3.07,0.77,4.52,1.35c1.01,0.39,2,0.85,2.94,1.35c10.45,5.62,16.45,17.61,13.92,29.84 C415.27,403.29,405.1,411.89,393.33,412.97z M390.85,414.08c-1.94,0-3.89-0.2-5.8-0.6c-7.46-1.54-13.88-5.9-18.06-12.27 c-4.19-6.37-5.64-13.98-4.1-21.44c2.57-12.39,12.75-21.49,25.35-22.64c2.8-0.26,5.62-0.09,8.37,0.48 c1.62,0.34,3.2,0.8,4.69,1.4c1.02,0.39,2.05,0.87,3.05,1.4c11.03,5.93,16.97,18.64,14.43,30.92 c-2.56,12.39-12.75,21.48-25.34,22.63l0,0C392.57,414.04,391.71,414.08,390.85,414.08z M390.81,359.01 c-0.8,0-1.6,0.04-2.39,0.11c-11.71,1.07-21.18,9.53-23.57,21.05c-1.43,6.94-0.08,14.02,3.81,19.94 c3.89,5.92,9.86,9.97,16.8,11.41c2.57,0.54,5.19,0.69,7.79,0.45l0,0c11.71-1.07,21.18-9.53,23.57-21.05 c2.36-11.42-3.15-23.24-13.42-28.75c-0.92-0.5-1.87-0.93-2.83-1.3c-1.39-0.55-2.86-0.99-4.37-1.3 C394.42,359.2,392.62,359.01,390.81,359.01z"
  }))))), /*#__PURE__*/React.createElement("g", null, _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 327.21,
    y: 395.46,
    className: "st147",
    width: 18.22,
    height: 61.41
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_165_",
    gradientUnits: "userSpaceOnUse",
    x1: 326.2061,
    y1: 426.1606,
    x2: 346.4209,
    y2: 426.1606
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "M345.42,457.87h-18.21c-0.55,0-1-0.45-1-1v-61.41c0-0.55,0.45-1,1-1h18.21c0.55,0,1,0.45,1,1v61.41 C346.42,457.42,345.97,457.87,345.42,457.87z M328.21,455.87h16.21v-59.41h-16.21V455.87z"
  }))), /*#__PURE__*/React.createElement("g", null, _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st147",
    points: "316.29,406.1 334.51,406.1 345.42,395.46 327.21,395.46  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_166_",
    gradientUnits: "userSpaceOnUse",
    x1: 315.2939,
    y1: 400.7759,
    x2: 346.421,
    y2: 400.7759
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "st169",
    d: "M334.51,407.1h-18.22c-0.41,0-0.77-0.25-0.93-0.62c-0.15-0.38-0.06-0.81,0.23-1.09l10.91-10.64 c0.19-0.18,0.44-0.29,0.7-0.29h18.21c0.41,0,0.77,0.25,0.93,0.62c0.15,0.38,0.06,0.81-0.23,1.09l-10.91,10.64 C335.02,406.99,334.77,407.1,334.51,407.1z M318.75,405.1h15.35l8.86-8.64h-15.35L318.75,405.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_167_",
    gradientUnits: "userSpaceOnUse",
    x1: 345.4209,
    y1: 426.1616,
    x2: 436.2339,
    y2: 426.1616
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#02247D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03BEF2"
    }
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 345.42,
    y: 395.46,
    className: "st170",
    width: 90.81,
    height: 61.41
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_168_",
    gradientUnits: "userSpaceOnUse",
    x1: 344.4209,
    y1: 426.1606,
    x2: 437.2339,
    y2: 426.1606
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "M437.23,457.87h-92.81v-63.41h92.81V457.87z M346.42,455.87h88.81v-59.41h-88.81V455.87z"
  }))), /*#__PURE__*/React.createElement("g", null, _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st147",
    points: "447.15,406.1 356.33,406.1 345.42,395.46 436.23,395.46  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_169_",
    gradientUnits: "userSpaceOnUse",
    x1: 344.4209,
    y1: 400.7759,
    x2: 448.1455,
    y2: 400.7759
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "st172",
    d: "M447.15,407.1h-90.81c-0.26,0-0.51-0.1-0.7-0.28l-10.91-10.64c-0.29-0.29-0.38-0.72-0.23-1.09 c0.15-0.38,0.52-0.62,0.93-0.62h90.81c0.26,0,0.51,0.1,0.7,0.29l10.91,10.64c0.29,0.28,0.38,0.71,0.23,1.09 C447.92,406.85,447.55,407.1,447.15,407.1z M356.74,405.1h87.95l-8.86-8.64h-87.95L356.74,405.1z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog3);
export default __webpack_public_path__ + "static/media/blog3.969725e82b711d5a2f1e283aee0e77d0.svg";
export { ForwardRef as ReactComponent };